MinimogTheme.pubSubEvents = {
  cartError: "cart-error",
  cartUpdate: "cart-update",
  openCartDrawer: "open-cart-drawer",
  openSearchPopup: "open-search-popup",
};
const requestDefaultConfigs = {
  mode: "same-origin",
  credentials: "same-origin",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
};
(MinimogTheme.config = {
  mqlMobile: !1,
  mqlTablet: !1,
  mediaQueryMobile: "screen and (max-width: 767px)",
  mediaQueryTablet: "screen and (max-width: 1023px)",
  swiperModules: [MinimogLibs.Swiper.Navigation, MinimogLibs.Swiper.Pagination],
}),
  (MinimogTheme.initWhenVisible = function (e) {
    const t = e.threshold ? e.threshold : 0;
    new IntersectionObserver(
      (t, i) => {
        t.forEach((t) => {
          t.isIntersecting &&
            "function" == typeof e.callback &&
            (e.callback(), i.unobserve(t.target));
        });
      },
      { rootMargin: `0px 0px ${t}px 0px` }
    ).observe(e.element);
  }),
  (function () {
    const e = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
    (MinimogTheme.config.mqlMobile = e.matches),
      (e.onchange = (e) => {
        e.matches
          ? ((MinimogTheme.config.mqlMobile = !0),
            document.dispatchEvent(new CustomEvent("matchMobile")))
          : ((MinimogTheme.config.mqlMobile = !1),
            document.dispatchEvent(new CustomEvent("unmatchMobile")));
      });
    const t = window.matchMedia(MinimogTheme.config.mediaQueryTablet);
    (MinimogTheme.config.mqlTablet = t.matches),
      (t.onchange = (e) => {
        e.matches
          ? ((MinimogTheme.config.mqlTablet = !0),
            document.dispatchEvent(new CustomEvent("matchTablet")))
          : ((MinimogTheme.config.mqlTablet = !1),
            document.dispatchEvent(new CustomEvent("unmatchTablet")));
      });
  })();
class Tabs {
  constructor(e, t = () => {}) {
    (this.selectors = {
      tabHeaders: [".m-tab-header"],
      tabContents: [".m-tab-content"],
    }),
      (this.activeClass = "active"),
      (this.currentActiveIndex = -1),
      (this.currentTab = null),
      (this.container = e),
      (this.cb = t),
      (this.domNodes = queryDomNodes(this.selectors, e)),
      (this.customSelect = this.container.querySelector("m-select-component")),
      this.init(),
      this.setActiveTab(0);
  }
  init() {
    addEventDelegate({
      context: this.container,
      selector: this.selectors.tabHeaders[0],
      handler: (e, t) => {
        let i;
        e.preventDefault(),
          t && (i = Number(t.dataset.index)),
          this.setActiveTab(i),
          this.cb(t);
      },
    });
  }
  setActiveTab(e) {
    const { tabHeaders: t, tabContents: i } = this.domNodes;
    if (i.length && -1 !== e && this.currentActiveIndex !== e) {
      let s, o, n;
      if (
        ((s = t && t[this.currentActiveIndex]),
        (o = t && t[e]),
        this.customSelect && o)
      ) {
        "select" === this.customSelect.dataset.tabHeader &&
          this.customSelect.updateCustomSelectChecked(e, o.innerHTML),
          MinimogTheme.config.mqlMobile &&
            this.customSelect.updateCustomSelectChecked(e, o.innerHTML),
          document.addEventListener("matchMobile", () =>
            this.customSelect.updateCustomSelectChecked(e, o.innerHTML)
          );
      }
      (n = i && i[e]),
        s && s.classList.remove(this.activeClass),
        this.currentTab && this.currentTab.classList.remove(this.activeClass),
        o && o.classList.add(this.activeClass),
        n && n.classList.add(this.activeClass),
        setTimeout(() => (n.style.opacity = 1)),
        (this.currentActiveIndex = e),
        (this.currentTab = n);
    }
  }
}
function isStorageSupported(e) {
  if (window.self !== window.top) return !1;
  const t = "minimog:check";
  let i;
  "session" === e && (i = window.sessionStorage),
    "local" === e && (i = window.localStorage);
  try {
    return i.setItem(t, "1"), i.removeItem(t), !0;
  } catch (e) {
    return !1;
  }
}
function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
(window.MinimogTheme.Tabs = Tabs),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var i = 0, s = e.options.length; i < s; i++) {
      var o = e.options[i];
      if (t == o.value || t == o.innerHTML) return (e.selectedIndex = i), i;
    }
  }),
  (Shopify.addListener = function (e, t, i) {
    e.addEventListener
      ? e.addEventListener(t, i, !1)
      : e.attachEvent("on" + t, i);
  }),
  (Shopify.CountryProvinceSelector = function (e, t, i) {
    (this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(i.hideElement || t)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
      ),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e &&
        this.provinceEl.options.length > 0 &&
        Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = (o =
          this.countryEl.options[this.countryEl.selectedIndex]).getAttribute(
          "data-provinces"
        ),
        i = JSON.parse(t);
      if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var s = 0; s < i.length; s++) {
          var o;
          ((o = document.createElement("option")).value = i[s][0]),
            (o.innerHTML = i[s][1]),
            this.provinceEl.appendChild(o);
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild; ) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      var i = 0;
      for (t.length; i < t.length; i++) {
        var s = document.createElement("option");
        (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
      }
    },
  });
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
  var i = getFocusableElements(e),
    s = i[0],
    o = i[i.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (t) => {
      (t.target !== e && t.target !== o && t.target !== s) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (t) {
      "TAB" === t.code.toUpperCase() &&
        (t.target !== o || t.shiftKey || (t.preventDefault(), s.focus()),
        (t.target !== e && t.target !== s) ||
          !t.shiftKey ||
          (t.preventDefault(), o.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    t.focus(),
    "INPUT" === t.tagName &&
      ["search", "text", "email", "url"].includes(t.type) &&
      t.value &&
      t.setSelectionRange(0, t.value.length);
}
function removeTrapFocus(e = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    e && e.focus();
}
function getRequestDefaultConfigs() {
  return JSON.parse(JSON.stringify(requestDefaultConfigs));
}
function fetchJSON(e, t = getRequestDefaultConfigs()) {
  return fetch(e, t).then(function (e) {
    if (!e.ok) throw e;
    return e.json();
  });
}
const cache = new Map();
function fetchCache(e, t = getRequestDefaultConfigs()) {
  return new Promise((i, s) => {
    let o = cache.get(e);
    if (o) return i(o);
    fetch(e, t)
      .then((t) => {
        (o = t.text()), cache.set(e, o), i(o);
      })
      .catch(s);
  });
}
const sectionCache = new Map();
function fetchSection(e, t = {}) {
  const { url: i, fromCache: s = !1, params: o = {} } = t;
  return new Promise((t, n) => {
    const r = new URL(i || window.location.href);
    if (
      (r.searchParams.set("section_id", e),
      Object.entries(o).forEach(([e, t]) => r.searchParams.set(e, t)),
      s)
    ) {
      const e = sectionCache.get(r);
      if (e) return t(e);
    }
    const reqConfig = getRequestDefaultConfigs();
    fetch(r, reqConfig)
      .then((t) => {
        if (t.ok) return t.text();
        n(`Failed to load section: ${e}`);
      })
      .then((e) => {
        const i = generateDomFromString(e);
        sectionCache.set(r, i), t(i);
      })
      .catch(n);
  });
}
const cache2 = new Map();
function fetchJsonCache(e, t = requestDefaultConfigs) {
  return new Promise((i, s) => {
    if (cache2.get(e)) return i(cache2.get(e));
    fetch(e, t)
      .then((t) => {
        if (t.ok) {
          const s = t.json();
          return i(s), cache2.set(e, s), s;
        }
        s(t);
      })
      .catch(s);
  });
}
function formatMoney(e, t) {
  "string" == typeof e && (e = e.replace(".", ""));
  let i = "";
  const s = /\{\{\s*(\w+)\s*\}\}/,
    o = t || "${{amount}}";
  function n(e, t = 2, i = ",", s = ".") {
    if (isNaN(e) || null == e) return 0;
    const o = (e = (e / 100).toFixed(t)).split(".");
    return (
      o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`) +
      (o[1] ? s + o[1] : "")
    );
  }
  switch (o.match(s)[1]) {
    case "amount":
      i = n(e, 2);
      break;
    case "amount_no_decimals":
      i = n(e, 0);
      break;
    case "amount_with_comma_separator":
      i = n(e, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = n(e, 0, ".", ",");
  }
  return o.replace(s, i);
}
function validateForm(e) {
  const t = [];
  if (!e) return t;
  return (
    e
      .querySelectorAll(
        '[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])'
      )
      .forEach((i) => {
        if ((i.classList.remove("form-control--warning"), "radio" === i.type)) {
          const s = e.querySelectorAll(`input[name="${i.name}"]`);
          Array.from(s).some((e) => e.checked) ||
            (t.push(i), i.classList.add("form-control--warning"));
        } else i.value || (t.push(i), i.classList.add("form-control--warning"));
      }),
    t
  );
}
function generateDomFromString(e, t = "div") {
  const i = document.createElement(t);
  return (i.innerHTML = e), i;
}
function generateDomeFromStringNew(e, t = "div") {
  return new DOMParser().parseFromString(e, "text/html").querySelector(t);
}
function fetchCountDown(e) {
  const t = MinimogSettings.foxKitBaseUrl
    ? `https://${MinimogSettings.foxKitBaseUrl}`
    : "";
  return new Promise((i, s) => {
    let o = `${t}/api/public/countdown?shop=${window.Shopify.shop}&collectionIds=${e}`;
    fetch(o)
      .then((e) => e.json())
      .then(i)
      .catch(s);
  });
}
function loadAssets(e = [], t, i = () => {}, s = {}) {
  const o = t || Math.random().toString(36).slice(2);
  window.MinimogLibs.loadjs.isDefined(t) || window.MinimogLibs.loadjs(e, o),
    window.MinimogLibs.loadjs.ready(o, i);
}
function pauseAllMedia(e = document) {
  e.querySelectorAll(".js-youtube").forEach((e) => {
    e.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  }),
    e.querySelectorAll(".js-vimeo").forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    e.querySelectorAll("video").forEach((e) => e.pause()),
    e.querySelectorAll("product-model").forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    });
}
function loadJS(e, t = document.body, i = !1, s = !0) {
  return new Promise((o, n) => {
    const r = t.ownerDocument,
      a = r.querySelector(`script[src="${e}"]`);
    if (a)
      return a.dataset.loaded
        ? o(!0)
        : void a.addEventListener("load", () => {
            (a.dataset.loaded = !0), o(!0);
          });
    const l = r.createElement("script");
    (l.src = e),
      (l.async = i),
      (l.defer = s),
      l.addEventListener("load", () => {
        (l.dataset.loaded = !0), o(!0);
      }),
      (l.onerror = n),
      t.appendChild(l);
  });
}
function loadCSS(e, t = document.head) {
  return new Promise((i, s) => {
    const o = t.ownerDocument,
      n = o.querySelector(`link[href="${e}"]`);
    if (n)
      return n.dataset.loaded
        ? i(!0)
        : void n.addEventListener("load", () => {
            (n.dataset.loaded = !0), i(!0);
          });
    const r = o.createElement("link");
    (r.rel = "stylesheet"),
      (r.href = e),
      r.addEventListener("load", () => {
        (r.dataset.loaded = !0), i(!0);
      }),
      (r.onerror = s),
      t.appendChild(r);
  });
}
function addEventDelegate({
  context: e = document.documentElement,
  event: t = "click",
  selector: i,
  handler: s,
  capture: o = !1,
}) {
  const n = function (e) {
    for (let t = e.target; t && t !== this; t = t.parentNode)
      if (t.matches(i)) {
        s.call(t, e, t);
        break;
      }
  };
  return (
    e.addEventListener(t, n, o),
    () => {
      e.removeEventListener(t, n, o);
    }
  );
}
function debounce(e, t) {
  let i;
  return (...s) => {
    clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
  };
}
function _validateOptionsArray(e) {
  if (Array.isArray(e) && "object" == typeof e[0])
    throw new Error(e + "is not a valid array of options.");
}
function _validateProductStructure(e) {
  if ("object" != typeof e) throw new TypeError(e + " is not an object.");
  if (0 === Object.keys(e).length && e.constructor === Object)
    throw new Error(e + " is empty.");
}
function getVariantFromOptionArray(e, t) {
  return (
    _validateProductStructure(e),
    _validateOptionsArray(t),
    e.variants.filter(function (e) {
      return t.every(function (t, i) {
        return e.options[i] === t;
      });
    })[0] || null
  );
}
function getSizedImageUrl(e, t) {
  if (null === t) return e;
  if ("master" === t) return removeProtocol(e);
  var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  if (i) {
    var s = e.split(i[0]),
      o = i[0];
    return removeProtocol(s[0] + "_" + t + o);
  }
  return null;
}
function removeProtocol(e) {
  return e.replace(/http(s)?:/, "");
}
function updateParam(e, t) {
  var { location: i } = window,
    s = [i.protocol, "//", i.host, i.pathname].join("");
  const o = window.location.search,
    n = new URLSearchParams(o);
  return (
    n.has(e)
      ? ("" !== t && "undefined" !== t && n.set(e, t),
        ("" !== t && "undefined" !== t) || n.delete(e))
      : t && n.append(e, t),
    window.history.replaceState({}, "", s + "?" + n.toString()),
    !1
  );
}
function createSearchLink(e) {
  const t = new URLSearchParams({
    type: "product",
    "options[unavailable_products]": "last",
    "options[prefix]": "last",
    q: e,
  });
  return `${window.MinimogSettings.routes.search_url}?${t.toString()}`;
}
function refreshProductReview() {
  if (
    ("undefined" != typeof SMARTIFYAPPS &&
      SMARTIFYAPPS.rv.installed &&
      SMARTIFYAPPS.rv.scmReviewsRate.actionCreateReviews(),
    "undefined" != typeof Yotpo && "function" == typeof Yotpo.API)
  ) {
    const e = new Yotpo.API(yotpo);
    e?.refreshWidgets();
  }
}
function reInitTooltip(e) {
  const t = e && e.querySelectorAll("[data-tippy-content]");
  t &&
    t.forEach((e) => {
      MinimogLibs.Tooltip(e, {
        animation: "shift-toward",
        touch: !1,
        hideOnClick: !1,
        onCreate(e) {
          const t = e.reference.dataset.tippyTheme || "m-color-background-1";
          (e.reference.classList.contains("m-wishlist-button") ||
            e.reference.classList.contains("m-compare-button")) &&
            e.setProps({ hideOnClick: !1 }),
            e.setProps({ theme: t });
        },
      });
    });
}
function queryDomNodes(e = {}, t = document) {
  return Object.entries(e).reduce((e, [i, s]) => {
    const o = "string" == typeof s,
      n = o ? "querySelector" : "querySelectorAll",
      r = o ? s : s[0];
    return t && (e[i] = t[n](r)), !o && e[i] && (e[i] = [...e[i]]), e;
  }, {});
}
function getScrollbarWidth() {
  if (window.innerWidth <= document.documentElement.clientWidth) return 0;
  const e = document.createElement("div");
  (e.style.visibility = "hidden"),
    (e.style.overflow = "scroll"),
    (e.style.msOverflowStyle = "scrollbar"),
    document.body.appendChild(e);
  const t = document.createElement("div");
  e.appendChild(t);
  const i = e.offsetWidth - t.offsetWidth;
  return e.parentNode.removeChild(e), i;
}
function spinner(e = "") {
  return `<svg class="animate-spin m:hidden m-svg-icon--medium ${e}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">\n    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>\n    <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>\n  </svg>`;
}
function fetchConfig(e = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${e}` },
  };
}
function setCookie(e, t, i) {
  var s = new Date();
  s.setTime(s.getTime() + 24 * i * 60 * 60 * 1e3);
  var o = "expires=" + s.toUTCString();
  document.cookie = e + "=" + t + ";" + o + ";path=/";
}
function getCookie(e) {
  for (
    var t = e + "=", i = decodeURIComponent(document.cookie).split(";"), s = 0;
    s < i.length;
    s++
  ) {
    for (var o = i[s]; " " === o.charAt(0); ) o = o.substring(1);
    if (0 === o.indexOf(t)) return o.substring(t.length, o.length);
  }
  return "";
}
function formatUrl(e, t, i) {
  let s;
  const { routes: o } = MinimogSettings;
  return (
    (s = `${o.root.endsWith("/") ? "" : o.root}/${e}/${t}`),
    i && (s += `?${i}`),
    s
  );
}
!(function () {
  const e = document.querySelectorAll("[data-ps-item]");
  e && e.forEach((e) => (e.href = createSearchLink(e.dataset.psQuery)));
})();
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector('[id^="Deferred-Poster-"]');
    e && e.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(e = !0) {
    if (
      ((this.autoPlay = "true" === this.dataset.autoPlay),
      this.autoPlay || window.pauseAllMedia(),
      !this.getAttribute("loaded"))
    ) {
      const t = document.createElement("div");
      t.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(!0)
      ),
        this.setAttribute("loaded", !0);
      const i = this.appendChild(
        t.querySelector("video, model-viewer, iframe")
      );
      (this.deferredElement = i), e && i.focus(), this.playVideo(i);
    }
  }
  playVideo(e) {
    if (!this.autoPlay)
      if (e.classList.contains("js-youtube")) {
        const t = e.src.indexOf("?") > -1 ? "&" : "?";
        e.src += t + "autoplay=1&mute=1";
      } else if (e.classList.contains("js-vimeo")) {
        const t = e.src.indexOf("?") > -1 ? "&" : "?";
        e.src += t + "autoplay=1&muted=1";
      } else e.setAttribute("autoplay", "autoplay"), e.play();
  }
}
customElements.define("deferred-media", DeferredMedia);
class ResponsiveImage extends HTMLElement {
  get intersecting() {
    return this.hasAttribute("intersecting");
  }
  constructor() {
    super(),
      (this.img = this.querySelector("img")),
      (this.src = this.img.src),
      (this.observerCallback = this.observerCallback.bind(this)),
      this.img &&
        ((this.loadImage = this.loadImage.bind(this)),
        (this.img.onload = this.onLoad.bind(this))),
      this.img.complete &&
        (this.removeAttribute(""), this.classList.add("m-image-loaded"));
  }
  connectedCallback() {
    (this.img.src = ""),
      "IntersectionObserver" in window
        ? this.initIntersectionObserver()
        : this.loadImage();
  }
  disconnectedCallback() {
    this.disconnectObserver();
  }
  loadImage() {
    this.setAttribute("intersecting", "true"),
      this.img &&
        ((this.img.src = this.src),
        (this.img.width = this.clientWidth),
        (this.img.height = this.clientHeight),
        (this.img.sizes = this.clientWidth + "px"));
  }
  onLoad() {
    this.removeAttribute(""), this.classList.add("m-image-loaded");
  }
  observerCallback(e, t) {
    e[0].isIntersecting && (t.unobserve(this), this.loadImage());
  }
  initIntersectionObserver() {
    if (this.observer) return;
    (this.observer = new IntersectionObserver(this.observerCallback, {
      rootMargin: "10px",
    })),
      this.observer.observe(this);
  }
  disconnectObserver() {
    this.observer &&
      (this.observer.disconnect(),
      (this.observer = null),
      delete this.observer);
  }
}
customElements.define("responsive-image", ResponsiveImage);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super(),
      (this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
      }),
      (this.enableSlider = "true" === this.dataset.enableSlider),
      (this.showPagination = "true" === this.dataset.showPagination),
      (this.showNavigation = "true" === this.dataset.showNavigation),
      (this.paginationType = this.dataset.paginationType || "bullets"),
      (this.mobileLayout = this.dataset.mobileLayout),
      (this.items = this.dataset.items),
      (this.laptopItems = this.dataset.laptopItems),
      (this.tabletItems = this.dataset.tabletItems),
      (this.mobileItems = this.dataset.mobileItems || 2),
      (this.container = this.closest(".m-section"));
  }
  connectedCallback() {
    "IntersectionObserver" in window &&
      new IntersectionObserver(
        ((e, t) => {
          e[0].isIntersecting &&
            (t.unobserve(this),
            fetch(this.dataset.url)
              .then((e) => e.text())
              .then((e) => {
                const t = generateDomFromString(e).querySelector(
                  "product-recommendations"
                );
                t &&
                  t.innerHTML.trim().length &&
                  ((this.innerHTML = t.innerHTML),
                  (this.totalProducts =
                    t.querySelectorAll(".m-product-card").length),
                  this.products <= 0 &&
                    this.container &&
                    this.container.classList.add("m:hidden"),
                  this.initByScreenSize(),
                  document.addEventListener("matchMobile", () => {
                    this.initByScreenSize();
                  }),
                  document.addEventListener("unmatchMobile", () => {
                    this.initByScreenSize();
                  }),
                  MinimogTheme.CompareProduct.setCompareButtonsState(),
                  MinimogTheme.Wishlist.setWishlistButtonsState(),
                  reInitTooltip(this));
              })
              .catch((e) => {}));
        }).bind(this),
        { rootMargin: "0px 0px 400px 0px" }
      ).observe(this);
  }
  initByScreenSize() {
    const { slideContainer: e, slideControls: t } = queryDomNodes(
      this.selectors,
      this
    );
    this.enableSlider &&
      (MinimogTheme.config.mqlMobile && "slider" !== this.mobileLayout
        ? (t && t.classList.add("m:hidden"),
          e && e.classList.remove("swiper"),
          this.swiper && this.swiper.destroy(!1, !0))
        : (t && t.classList.remove("m:hidden"), this.initSlider())),
      (!this.enableSlider || this.totalProducts <= parseInt(this.items)) &&
        t &&
        t.classList.add("m:hidden");
  }
  initSlider() {
    const { slideContainer: e, slideControls: t } = queryDomNodes(
        this.selectors,
        this
      ),
      i = t && t.querySelector(".m-slider-controls__button-prev"),
      s = t && t.querySelector(".m-slider-controls__button-next");
    e && e.classList.add("swiper");
    let o = this;
    (this.slider = new MinimogLibs.Swiper(e, {
      modules: MinimogTheme.config.swiperModules,
      slidesPerView: parseInt(this.mobileItems),
      slidesPerGroup: 1,
      loop: !(this.totalProducts <= parseInt(this.items)),
      navigation: !!this.showNavigation && { nextEl: s, prevEl: i },
      pagination: !!this.showPagination && {
        el: this.querySelector(".swiper-pagination"),
        type: this.paginationType,
        clickable: !0,
      },
      breakpoints: {
        768: {
          slidesPerView: this.tabletItems ? parseInt(this.tabletItems) : 3,
        },
        1024: {
          slidesPerView: this.laptopItems ? parseInt(this.laptopItems) : 4,
        },
        1280: { slidesPerView: parseInt(this.items) },
      },
      threshold: 2,
      on: {
        init: function () {
          setTimeout(() => {
            const e = o.querySelector(".m-product-card");
            if (e && t) {
              const i = e.querySelector(".m-image"),
                s = t.querySelector(".m-slider-controls__button-prev"),
                o = t.querySelector(".m-slider-controls__button-next"),
                n = window.getComputedStyle(e).getPropertyValue("padding-top"),
                r = s.offsetHeight,
                a = i.clientHeight;
              t.style.setProperty("--nav-offset-top", parseInt(a) / 2 + "px"),
                t.style.setProperty(
                  "--nav-transform",
                  (-1 * parseInt(r)) / 2 + parseInt(n) + "px"
                ),
                setTimeout(() => {
                  s.classList.remove("m:opacity-0"),
                    o.classList.remove("m:opacity-0");
                }, 150);
            }
          }, 100);
        },
      },
    })),
      (this.swiper = e && e.swiper);
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class ComplementaryProducts extends HTMLElement {
  constructor() {
    super(),
      (this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
      }),
      (this.enableSlider = "true" === this.dataset.enableSlider),
      (this.showNavigation = "true" === this.dataset.showNavigation),
      (this.items = this.dataset.items),
      (this.laptopItems = this.dataset.laptopItems),
      (this.tabletItems = this.dataset.tabletItems),
      (this.mobileItems = this.dataset.mobileItems || 2);
  }
  connectedCallback() {
    "IntersectionObserver" in window &&
      new IntersectionObserver(
        ((e, t) => {
          e[0].isIntersecting &&
            (t.unobserve(this),
            fetch(this.dataset.url)
              .then((e) => e.text())
              .then((e) => {
                const t = generateDomFromString(e).querySelector(
                  "complementary-products"
                );
                t &&
                  t.innerHTML.trim().length &&
                  ((this.innerHTML = t.innerHTML),
                  (this.totalProducts =
                    t.querySelectorAll(".m-product-card").length),
                  this.initSlider());
              })
              .catch((e) => {}));
        }).bind(this),
        { rootMargin: "0px 0px 400px 0px" }
      ).observe(this);
  }
  initSlider() {
    if (!this.enableSlider || this.totalProducts <= this.items) return;
    const { slideContainer: e, slideControls: t } = queryDomNodes(
        this.selectors,
        this
      ),
      i = t && t.querySelector(".m-slider-controls__button-prev"),
      s = t && t.querySelector(".m-slider-controls__button-next");
    e && e.classList.add("swiper");
    const o = [...MinimogTheme.config.swiperModules, MinimogLibs.Swiper.Grid];
    this.slider = new MinimogLibs.Swiper(e, {
      modules: o,
      slidesPerView: 1,
      slidesPerGroup: 1,
      grid: { rows: parseInt(this.dataset.rows) || 1, fill: "row" },
      navigation: !!this.showNavigation && { nextEl: s, prevEl: i },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        type: "fraction",
        clickable: !0,
      },
      threshold: 2,
    });
  }
}
if (
  (customElements.define("complementary-products", ComplementaryProducts),
  customElements.get("video-component") ||
    customElements.define(
      "video-component",
      class extends HTMLElement {
        constructor() {
          super(),
            MinimogTheme.initWhenVisible({
              element: this,
              callback: this.init.bind(this),
              threshold: 0,
            });
        }
        init() {
          this.querySelector('[id^="Deferred-Poster-"]').addEventListener(
            "click",
            this.loadContent.bind(this)
          );
        }
        loadContent() {
          if (!this.getAttribute("loaded")) {
            const e = document.createElement("div");
            e.appendChild(
              this.querySelector(
                "template"
              ).content.firstElementChild.cloneNode(!0)
            ),
              this.setAttribute("loaded", !0);
            const t = this.appendChild(
              e.querySelector("video, model-viewer, iframe")
            );
            if (
              ((this.deferredElement = t),
              this.deferredElement.classList.contains("js-youtube"))
            ) {
              const e = this.deferredElement.src.indexOf("?") > -1 ? "&" : "?";
              this.deferredElement.src += e + "autoplay=1";
            } else if (this.deferredElement.classList.contains("js-vimeo")) {
              const e = this.deferredElement.src.indexOf("?") > -1 ? "&" : "?";
              this.deferredElement.src += e + "autoplay=1";
            } else this.deferredElement.play();
          }
        }
      }
    ),
  !customElements.get("collapsible-tab"))
) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.init();
    }
    disconnectedCallback() {
      this.destroy();
    }
    init() {
      "true" === this.dataset.destroy ||
        (this.setDefaultData(),
        this.attachEvents(),
        "true" === this.getAttribute("open")
          ? ((this.selected = !0),
            this.classList.add(this.expandedClass),
            this.setExpandedAria())
          : ((this.content.style.height = this.collapsedHeight),
            this.classList.add(this.collapsedClass),
            this.setCollapsedAria()),
        this.content.removeAttribute("hidden"));
    }
    transitionendEventName() {
      let e,
        t = document.createElement("div"),
        i = {
          transition: "transitionend",
          OTransition: "otransitionend",
          MozTransition: "transitionend",
          WebkitTransition: "webkitTransitionEnd",
        };
      for (e in i)
        if (i.hasOwnProperty(e) && void 0 !== t.style[e]) return i[e];
    }
    expand() {
      const e = ((t) => {
        t.target === this.content &&
          (this.content.removeEventListener(this.transitionendevent, e),
          this.isOpen &&
            requestAnimationFrame(() => {
              (this.content.style.transition = "0"),
                (this.content.style.height = "auto"),
                requestAnimationFrame(() => {
                  (this.content.style.height = null),
                    (this.content.style.transition = null),
                    this.setExpandedAria(),
                    this.classList.add(this.expandedClass),
                    this.trySetTabIndex(this.content, 0),
                    this.fire("tabOpened");
                });
            }));
      }).bind(this);
      this.content.addEventListener(this.transitionendevent, e),
        (this.isOpen = !0),
        this.classList.remove(this.collapsedClass),
        (this.content.style.height = this.content.scrollHeight + "px");
    }
    collapse() {
      const e = ((t) => {
        t.target === this.content &&
          (this.content.removeEventListener(this.transitionendevent, e),
          this.isOpen ||
            (this.fire("elementClosed"),
            this.setCollapsedAria(),
            this.classList.add(this.collapsedClass),
            this.trySetTabIndex(this.content, -1)));
      }).bind(this);
      this.content.addEventListener(this.transitionendevent, e),
        (this.isOpen = !1),
        this.classList.remove(this.expandedClass),
        requestAnimationFrame(() => {
          (this.content.style.transition = "0"),
            (this.content.style.height = this.content.scrollHeight + "px"),
            requestAnimationFrame(() => {
              (this.content.style.transition = null),
                (this.content.style.height = this.collapsedHeight);
            });
        });
    }
    open() {
      (this.selected = !0),
        this.fire("elementSelected"),
        this.expand(),
        this.setAttribute("open", !0);
    }
    close() {
      (this.selected = !1),
        this.fire("elementUnselected"),
        this.collapse(),
        this.removeAttribute("open");
    }
    toggle(e) {
      if ((e.preventDefault(), this.selected)) this.close();
      else if ((this.open(), this.oneAtATime)) {
        const e = document.querySelectorAll("collapsible-tab"),
          t = this.closest("[data-first-level]");
        e.length &&
          e.forEach((e) => {
            e !== this && e.selected && t !== e && e.close();
          });
      }
    }
    trySetTabIndex(e, t) {
      const i = e.querySelectorAll(this.defaultElements);
      i &&
        i.forEach((e) => {
          e.setAttribute("tabindex", t);
        });
    }
    setExpandedAria() {
      this.trigger.setAttribute("aria-expanded", "true"),
        this.content.setAttribute("aria-hidden", "false");
    }
    setCollapsedAria(e) {
      this.trigger.setAttribute("aria-expanded", "false"),
        this.content.setAttribute("aria-hidden", "true");
    }
    attachEvents() {
      this.trigger.addEventListener("click", (e) => this.toggle(e));
    }
    setDefaultData() {
      (this.events = {
        elementSelected: [],
        tabOpened: [],
        elementUnselected: [],
        elementClosed: [],
      }),
        (this.transitionendevent = this.transitionendEventName()),
        (this.expandedClass = "is-expanded"),
        (this.collapsedClass = "is-collapsed"),
        (this.trigger = this.querySelector("[data-trigger]")),
        (this.content = this.querySelector("[data-content]")),
        (this.collapsedHeight = "0px"),
        (this.defaultElements = [
          "a",
          "button",
          "input:not(.focus-none)",
          "[data-trigger]",
        ]),
        (this.oneAtATime = !0),
        this.dataset.oneOpen &&
          (this.oneAtATime = "true" === this.dataset.oneOpen);
    }
    fire(e) {
      let t = this.events[e];
      if (t) for (let e = 0; e < t.length; e++) t[e](this);
    }
    on(e, t) {
      this.events[e] && this.events[e].push(t);
    }
    destroy() {
      this.trigger.removeEventListener("click", (e) => this.toggle(e)),
        this.content.removeAttribute("aria-hidden"),
        (this.content.style.height = "auto"),
        this.classList.remove(this.expandedClass, this.collapsedClass),
        this.removeAttribute("open");
    }
  }
  customElements.define("collapsible-tab", e);
}
if (!customElements.get("m-slideshow")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".swiper",
      }),
        (this.domNodes = queryDomNodes(this.selectors, this)),
        (this.pagination = "true" === this.dataset.pagination),
        (this.navigation = "true" === this.dataset.navigation),
        (this.autoplay = "true" === this.dataset.autoplay || !1),
        (this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 5),
        (this.effect = this.dataset.effect),
        (this.showContentBelow = "true" === this.dataset.showContentBelow),
        this.initSlider();
    }
    initSlider() {
      const { slideContainer: e } = queryDomNodes(this.selectors, this);
      this.controlsContainer = this.querySelector(".m-slider-controls");
      const t =
          this.controlsContainer &&
          this.controlsContainer.querySelector(
            ".m-slider-controls__button-prev"
          ),
        i =
          this.controlsContainer &&
          this.controlsContainer.querySelector(
            ".m-slider-controls__button-next"
          ),
        s = [
          ...MinimogTheme.config.swiperModules,
          MinimogLibs.Swiper.EffectFade,
          MinimogLibs.Swiper.Autoplay,
        ];
      (this.slider = new MinimogLibs.Swiper(e, {
        modules: s,
        slidesPerView: 1,
        loop: !0,
        slidesPerGroup: 1,
        effect: this.effect,
        fadeEffect: { crossFade: !0 },
        autoplay: !!this.autoplay && {
          delay: 1e3 * this.autoplaySpeed,
          disableOnInteraction: !1,
        },
        navigation: !!this.navigation && { nextEl: i, prevEl: t },
        pagination: !!this.pagination && {
          el: this.querySelector(".swiper-pagination"),
          type: "fraction",
          clickable: !0,
        },
        on: {
          init: (e) => {
            const t =
              e.slides[e.activeIndex].querySelector(".m-slide__content");
            (this.currentColorScheme = t && t.dataset.colorScheme),
              this.controlsContainer &&
                this.controlsContainer.classList.add(this.currentColorScheme);
          },
        },
        threshold: 2,
      })),
        this.slider.on("slideChange", (e) => {
          this.onSlideChange(e),
            document.addEventListener("matchMobile", () => {
              this.onSlideChange(e);
            }),
            document.addEventListener("unmatchMobile", () => {
              this.onSlideChange(e);
            });
        }),
        this.showContentBelow &&
          (this.setColorScheme(),
          document.addEventListener("matchMobile", () => {
            this.setColorScheme();
          }),
          document.addEventListener("unmatchMobile", () => {
            this.setColorScheme();
          })),
        document.addEventListener("shopify:block:select", (e) =>
          this.onBlockSelect(e)
        );
    }
    onSlideChange(e) {
      const { activeIndex: t, slides: i } = e,
        s = i[t],
        o = s && s.querySelector(".m-slide__content"),
        n = o && o.dataset.colorScheme;
      (MinimogTheme.config.mqlMobile && this.showContentBelow) ||
        (this.controlsContainer &&
          this.controlsContainer.classList.remove(this.currentColorScheme),
        this.controlsContainer && this.controlsContainer.classList.add(n),
        (this.currentColorScheme = n));
    }
    setColorScheme() {
      const e = this.querySelectorAll(".m-slide__content");
      MinimogTheme.config.mqlMobile
        ? (e.forEach((e) => e.classList.add("m-color-background-1")),
          this.controlsContainer &&
            this.controlsContainer.classList.remove(this.currentColorScheme),
          this.controlsContainer &&
            this.controlsContainer.classList.add("m-color-background-1"))
        : (e.forEach((e) => e.classList.remove("m-color-background-1")),
          this.controlsContainer &&
            this.controlsContainer.classList.remove("m-color-background-1"),
          this.controlsContainer &&
            this.controlsContainer.classList.add(this.currentColorScheme));
    }
    onBlockSelect(e) {
      const t = e.target,
        i = Number(t.dataset.index);
      this.slider && this.slider.slideToLoop(i);
    }
  }
  customElements.define("m-slideshow", e);
}
if (!customElements.get("m-testimonials")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.design = this.dataset.design),
        (this.containerType = this.dataset.container),
        (this.autoplay = "true" === this.dataset.autoplay),
        (this.container = this.closest(".m-testimonials")),
        (this.sliderContainer = this.querySelector(".swiper"));
    }
    connectedCallback() {
      (this.defaultSettings = {
        pagination: {
          el: this.container.querySelector(".swiper-pagination"),
          clickable: !0,
        },
        navigation: {
          nextEl: this.container.querySelector(
            ".m-slider-controls__button-next"
          ),
          prevEl: this.container.querySelector(
            ".m-slider-controls__button-prev"
          ),
        },
        autoplay: !!this.autoplay && {
          delay: 5e3,
          pauseOnMouseEnter: !1,
          disableOnInteraction: !1,
        },
        loop: !0,
        slidesPerView: 1,
        threshold: 2,
      }),
        (this.settings = {});
      let e = 400;
      switch (this.design) {
        case "testimonials-1":
          this.settings = {
            centeredSlides: !0,
            centeredSlidesBounds: !0,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            speed: 300,
            slideToClickedSlide: !0,
            loop: !0,
            breakpoints: {
              768: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 20,
                speed: 1e3,
              },
              1280: { slidesPerView: 5, slidesPerGroup: 3, spaceBetween: 30 },
              1920: { slidesPerView: 7, slidesPerGroup: 3 },
            },
          };
          break;
        case "testimonials-2":
          this.settings = {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: { 768: { slidesPerView: 3, slidesPerGroup: 3 } },
          };
          break;
        case "testimonials-3":
          this.settings = {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
              768: {
                slidesPerView: "full-width" === this.containerType ? 3 : 2,
              },
            },
          };
          break;
        case "testimonials-4":
          "full-width" === this.containerType && (e = 200),
            "grid" === this.containerType && (e = 150),
            (this.settings = {
              slidesPerView: 1,
              centeredSlides: !0,
              centeredSlidesBounds: !0,
              slideToClickedSlide: !0,
              loop: !0,
              pagination: {
                el: this.container.querySelector(".swiper-pagination"),
                clickable: !0,
                type: "fraction",
              },
              breakpoints: {
                768: { spaceBetween: parseInt(e / 4), slidesPerView: 3 },
                992: { spaceBetween: e / 2, slidesPerView: 3 },
                1920: { spaceBetween: e, slidesPerView: 3 },
              },
            });
          break;
        case "testimonials-6":
          this.settings = {
            slidesPerView: 1,
            loop: !0,
            pagination:
              "fraction" == this.dataset.paginationType
                ? {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: !0,
                    type: "fraction",
                  }
                : {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: !0,
                  },
            breakpoints: {
              768: { slidesPerView: 2 },
              1366: { slidesPerView: "grid" === this.containerType ? 2 : 3 },
              1600: { slidesPerView: "grid" === this.containerType ? 2 : 4 },
            },
          };
          break;
        case "testimonials-5":
          this.settings = { fade: { crossFade: !0 } };
      }
      const t = this.querySelector(".m-tabs");
      if (t) {
        const e = setInterval(() => {
          MinimogTheme.Tabs &&
            (clearInterval(e), (this.imagesTab = new MinimogTheme.Tabs(t)));
        }, 50);
      }
      this.initSlider();
    }
    initSlider() {
      (this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        modules: [
          ...MinimogTheme.config.swiperModules,
          MinimogLibs.Swiper.Manipulation,
          MinimogLibs.Swiper.Autoplay,
        ],
        ...this.defaultSettings,
        ...this.settings,
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      })),
        "testimonials-5" === this.design &&
          this.slider.on("slideChange", (e) => {
            const { realIndex: t } = e;
            this.imagesTab.setActiveTab(t);
          }),
        document.addEventListener("shopify:block:select", (e) =>
          this.onBlockSelect(e)
        );
    }
    onBlockSelect(e) {
      const t = e.target,
        i = Number(t.dataset.index);
      this.slider && this.slider.slideToLoop(i);
    }
  }
  customElements.define("m-testimonials", e);
}
if (!customElements.get("m-collection-list")) {
  class MCollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper", // slideContainer
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.paginationType = this.dataset.paginationType || "bullets";
      this.mobileLayout = this.dataset.mobileLayout;
      this.items = this.dataset.items;
      this.laptopItems = this.dataset.laptopItems;
      this.tabletItems = this.dataset.tabletItems;
      this.mobileItems = this.dataset.mobileItems || 2;

      this.needSaveLog = this.dataset.needSavelog;
      this.logAction = this.dataset.logAction;
      this.saveLog();

      this.initByScreenSize();
      document.addEventListener("matchMobile", () => {
        this.initByScreenSize();
      });
      document.addEventListener("unmatchMobile", () => {
        this.initByScreenSize();
      });
    }

    // 执行保存日志的操作
    saveLog() {
      if (!this.needSaveLog || !this.logAction) return;
      // 解析URL查询参数
      const urlParams = new URLSearchParams(window.location.search);
      const utm_source = urlParams.get("utm_source") || "";
      const utm_medium = urlParams.get("utm_medium") || "";
      const utm_id = urlParams.get("utm_id") || "";
      this.querySelectorAll(".m-collection-card").forEach((item, index) => {
        item.addEventListener("click", () => {
          const logData = {
            domain: window.location.href,
            action_type: this.logAction,
            utm_source,
            utm_medium,
            utm_id,
            request_json: { index: index + 1 },
          };
          sendBehaviorLog(logData);
        });
      });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer, slideControls } = queryDomNodes(
        this.selectors,
        this
      );

      if (MinimogTheme.config.mqlMobile && this.mobileLayout !== "slider") {
        slideControls?.classList.add("m:hidden");
        slideContainer.classList.remove("swiper");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        slideControls?.classList.remove("m:hidden");
        this.initSlider();
      }
    }

    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton =
        controlsContainer &&
        controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton =
        controlsContainer &&
        controlsContainer.querySelector(".m-slider-controls__button-next");

      slideContainer?.classList.add("swiper");

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        modules: MinimogTheme.config.swiperModules,
        slidesPerView: 2,
        slidesPerGroup: 1,
        loop: true,
        navigation: this.showNavigation
          ? {
              nextEl: nextButton,
              prevEl: prevButton,
            }
          : false,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              type: this.paginationType,
              clickable: true,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: this.tabletItems ? parseInt(this.tabletItems) : 3,
          },
          1024: {
            slidesPerView: this.laptopItems ? parseInt(this.laptopItems) : 4,
          },
          1280: {
            slidesPerView: parseInt(this.items),
            loopedSlides: parseInt(this.items) * 4,
          },
        },
        threshold: 2,
      });

      this.swiper = slideContainer?.swiper;
    }
  }

  customElements.define("m-collection-list", MCollectionList);
}
if (!customElements.get("m-multiple-columns")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
      }),
        (this.domNodes = queryDomNodes(this.selectors, this)),
        (this.enableSlider = "true" === this.dataset.enableSlider),
        (this.pagination = "true" === this.dataset.pagination),
        (this.navigation = "true" === this.dataset.navigation),
        (this.paginationType = this.dataset.paginationType || "bullets"),
        (this.items = this.dataset.items),
        (this.total = this.dataset.total),
        (this.mobileLayout = this.dataset.mobileLayout),
        this.initByScreenSize(),
        document.addEventListener("matchMobile", () => {
          this.initByScreenSize();
        }),
        document.addEventListener("unmatchMobile", () => {
          this.initByScreenSize();
        });
    }
    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer: e, slideControls: t } = queryDomNodes(
        this.selectors,
        this
      );
      MinimogTheme.config.mqlMobile && "slider" !== this.mobileLayout
        ? (t?.classList.add("m:hidden"),
          e.classList.remove("swiper"),
          this.swiper && this.swiper.destroy(!1, !0))
        : (t?.classList.remove("m:hidden"), this.initSlider());
    }
    initSlider() {
      const { slideContainer: e } = queryDomNodes(this.selectors, this),
        t = this.querySelector(".m-slider-controls"),
        i = t && t.querySelector(".m-slider-controls__button-prev"),
        s = t && t.querySelector(".m-slider-controls__button-next");
      e?.classList.add("swiper"),
        (this.slider = new MinimogLibs.Swiper(e, {
          modules: MinimogTheme.config.swiperModules,
          slidesPerView: 1,
          loop: !0,
          slidesPerGroup: 1,
          navigation: !!this.navigation && { nextEl: s, prevEl: i },
          pagination: !!this.pagination && {
            el: this.querySelector(".swiper-pagination"),
            type: this.paginationType,
            clickable: !0,
          },
          breakpoints: {
            768: { slidesPerView: this.items >= 3 ? 3 : this.items },
            1280: { slidesPerView: this.items },
          },
        })),
        (this.swiper = e?.swiper);
    }
  }
  customElements.define("m-multiple-columns", e);
}
if (
  (customElements.get("product-form") ||
    customElements.define(
      "product-form",
      class extends HTMLElement {
        constructor() {
          super(),
            (this.selectors = {
              form: "form",
              inputId: "[name=id]",
              submitButton: '[name="add"]',
              errorWrapper: ".m-product-form-message",
              customFields: ["[data-product-custom-field]"],
              dynamicCheckout: ".m-product-dynamic-checkout",
            });
        }
        connectedCallback() {
          (this.domNodes = queryDomNodes(this.selectors, this)),
            (this.form = this.domNodes.form),
            (this.submitButton = this.domNodes.submitButton),
            (this.domNodes.inputId.disabled = !1),
            (this.cart = document.querySelector("m-cart-drawer")),
            (this.cartPage = document.querySelector("m-cart")),
            (this.customFields = document.querySelectorAll(
              this.selectors.customFields
            )),
            this.domNodes.dynamicCheckout &&
              (this.enable_dynamic_checkout = !0),
            this.form.addEventListener(
              "submit",
              this.onSubmitHandler.bind(this)
            ),
            this.domNodes.dynamicCheckout &&
              this.customFields &&
              this.domNodes.dynamicCheckout.addEventListener(
                "click",
                (e) => {
                  const t = validateForm(
                    this.form.closest(".m-main-product__info")
                  );
                  t &&
                    t.length > 0 &&
                    (e.stopPropagation(),
                    window.MinimogTheme.Notification.show({
                      target: this.domNodes.errorWrapper,
                      method: "appendChild",
                      type: "warning",
                      message: window.MinimogStrings.requiredField,
                      delay: 100,
                    }));
                },
                !0
              );
        }
        toggleSpinner(e) {
          const t = e ? "add" : "remove";
          this.classList[t]("m-spinner-loading");
        }
        onSubmitHandler(e) {
          e.preventDefault(), this.toggleSpinner(!0);
          const t = validateForm(this.form.closest(".m-main-product__info"));
          if (t && t.length > 0)
            return (
              this.toggleSpinner(!1),
              window.MinimogTheme.Notification.show({
                target: this.domNodes.errorWrapper,
                method: "appendChild",
                type: "warning",
                message: window.MinimogStrings.requiredField,
              })
            );
          const i = fetchConfig("javascript");
          (i.headers["X-Requested-With"] = "XMLHttpRequest"),
            delete i.headers["Content-Type"];
          const s = new FormData(this.form);
          this.cart &&
            (s.append(
              "sections",
              this.cart.getSectionsToRender().map((e) => e.id)
            ),
            s.append("sections_url", window.location.pathname)),
            (i.body = s);
          const { MinimogSettings: o, MinimogStrings: n } = window;
          fetch(`${o.routes.cart_add_url}`, i)
            .then((e) => e.json())
            .then((e) => {
              if (e.status)
                return (
                  window.MinimogEvents.emit(
                    MinimogTheme.pubSubEvents.cartError,
                    {
                      source: "product-form",
                      productVariantId: s.get("id"),
                      errors: e.description,
                      message: e.message,
                    }
                  ),
                  (this.error = !0),
                  window.MinimogTheme.Notification.show({
                    target: this.domNodes.errorWrapper
                      ? this.domNodes.errorWrapper
                      : document.body,
                    method: "appendChild",
                    type: "warning",
                    message: e.message,
                    last: 3e3,
                    sticky: !this.domNodes.errorWrapper,
                  })
                );
              o.use_ajax_atc
                ? this.cart && o.enable_cart_drawer
                  ? (this.cart.renderContents(e),
                    MinimogTheme.Notification.show({
                      target: this.cart.querySelector("m-cart-drawer-items"),
                      method: "prepend",
                      type: "success",
                      message: n.itemAdded,
                      delay: 400,
                    }),
                    window.MinimogEvents.emit(
                      MinimogTheme.pubSubEvents.openCartDrawer
                    ))
                  : (window.MinimogTheme.Notification.show({
                      target: this.domNodes.errorWrapper
                        ? this.domNodes.errorWrapper
                        : document.body,
                      method: "appendChild",
                      type: "success",
                      message: n.itemAdded,
                      last: 3e3,
                      sticky: !this.domNodes.errorWrapper,
                    }),
                    fetchJSON(window.Shopify.routes.root + "cart.json").then(
                      (e) => {
                        if (e) {
                          const t = e.item_count;
                          document
                            .querySelectorAll(".m-cart-count-bubble")
                            .forEach((e) => {
                              t > 0
                                ? ((e.textContent = t),
                                  e.classList.remove("m:hidden"))
                                : e.classList.add("m:hidden");
                            });
                        }
                      }
                    ))
                : (window.location = o.routes.cart),
                (this.error = !1),
                window.MinimogEvents.emit(
                  MinimogTheme.pubSubEvents.cartUpdate,
                  e
                );
            })
            .catch((e) => {})
            .finally(() => {
              if ((this.toggleSpinner(!1), this.cart)) {
                const e = this.cart.querySelector("m-cart-drawer-items");
                this.cart.classList.contains("m-cart--empty") &&
                  this.cart.classList.remove("m-cart--empty"),
                  e &&
                    e.classList.contains("m-cart--empty") &&
                    e.classList.remove("m-cart--empty");
              }
              this.cartPage &&
                this.cartPage.classList.contains("m-cart--empty") &&
                this.cartPage.classList.remove("m-cart--empty");
            });
        }
      }
    ),
  !customElements.get("m-press"))
) {
  class e extends HTMLElement {
    constructor() {
      super(), (this.prevSlideIndex = 0);
    }
    connectedCallback() {
      this.initSlider();
    }
    initSlider() {
      const e = this.querySelector(".m-press__content"),
        t = this.querySelector(".m-press__list .swiper"),
        i = "true" === this.dataset.autoplay;
      (this.items = parseInt(this.dataset.items)),
        (this.canLoop =
          window.innerWidth < 1300 ? this.items > 3 : this.items > 5),
        (this.contentSlider = new MinimogLibs.Swiper(e, {
          modules: [
            MinimogLibs.Swiper.Navigation,
            MinimogLibs.Swiper.Pagination,
            MinimogLibs.Swiper.Thumbs,
          ],
          slidesPerView: 1,
          allowTouchMove: !1,
          fadeEffect: { crossFade: !0 },
        })),
        (this.navSlider = new MinimogLibs.Swiper(t, {
          modules: [
            MinimogLibs.Swiper.Navigation,
            MinimogLibs.Swiper.Pagination,
            MinimogLibs.Swiper.Thumbs,
          ],
          autoplay: !!i && { delay: 5e3 },
          items: 1,
          loop: this.canLoop,
          centeredSlides: this.canLoop,
          threshold: 2,
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: !0,
          },
          slideToClickedSlide: !0,
          breakpoints: {
            768: { slidesPerView: 3, navigation: !1 },
            1280: { slidesPerView: 5, navigation: !1 },
          },
          on: {
            init: function (e) {
              const t = e.slides[e.activeIndex];
              t && t.classList.add("m-press__logo--is-active");
            },
          },
        })),
        !this.canLoop &&
          this.navSlider.on("click", this._handleClick.bind(this)),
        this.navSlider.on("slideChange", this._handleChange.bind(this)),
        document.addEventListener("shopify:block:select", (e) =>
          this.onBlockSelect(e)
        );
    }
    _handleChange(e) {
      const { realIndex: t, activeIndex: i, slides: s } = e || {},
        o = this.querySelector(
          '.m-press__logo--is-active[data-index="' + this.prevSlideIndex + '"]'
        ),
        n = s[i];
      n && n.classList.add("m-press__logo--is-active"),
        o && o.classList.remove("m-press__logo--is-active"),
        this.contentSlider.slideTo(t),
        (this.prevSlideIndex = t);
    }
    _handleClick(e) {
      const { clickedIndex: t, clickedSlide: i } = e || {},
        s = this.querySelector(
          '.m-press__logo--is-active[data-index="' + this.prevSlideIndex + '"]'
        );
      i && i.classList.add("m-press__logo--is-active"),
        s && s.classList.remove("m-press__logo--is-active"),
        this.contentSlider.slideTo(t),
        (this.prevSlideIndex = t);
    }
    onBlockSelect(e) {
      const t = e.target,
        i = Number(t.dataset.index);
      this.contentSlider && this.contentSlider.slideToLoop(i),
        this.navSlider && this.navSlider.slideToLoop(i);
    }
  }
  customElements.define("m-press", e);
}
if (!customElements.get("m-featured-slider")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.selectors = {
          sliderContainer: ".m-featured-slider__products",
          slideImages: ["m-featured-slider__img"],
          slideImagesContainer: ".m-featured-slider__images",
          sliderControls: ".m-slider-controls",
          prevBtn: ".m-slider-controls__button-prev",
          nextBtn: ".m-slider-controls__button-next",
        }),
        (this.domNodes = queryDomNodes(this.selectors, this));
    }
    connectedCallback() {
      this.initSlider();
    }
    initSlider() {
      this.dataset.showNavigation;
      const e = "true" === this.dataset.showPagination,
        t = "true" === this.dataset.autoplay,
        i = this.dataset.timeout,
        s = [
          ...MinimogTheme.config.swiperModules,
          MinimogLibs.Swiper.Thumbs,
          MinimogLibs.Swiper.Autoplay,
        ];
      (this.slider = new MinimogLibs.Swiper(this.domNodes.sliderContainer, {
        modules: s,
        speed: 400,
        loop: !0,
        autoplay: !!t && { delay: parseInt(i), disableOnInteraction: !1 },
        pagination: !!e && {
          el: this.querySelector(".swiper-pagination"),
          type: "bullets",
          clickable: !0,
        },
        navigation: {
          nextEl: this.domNodes.nextBtn,
          prevEl: this.domNodes.prevBtn,
        },
      })),
        (this.imageSlider = new MinimogLibs.Swiper(
          this.domNodes.slideImagesContainer,
          {
            modules: s,
            speed: 500,
            loop: !0,
            effect: "fade",
            fadeEffect: { crossFade: !0 },
          }
        )),
        this.slider.on("activeIndexChange", (e) => {
          const { realIndex: t } = e;
          this.imageSlider.slideToLoop(t);
        }),
        this.imageSlider.on("activeIndexChange", (e) => {
          const { realIndex: t } = e;
          this.slider.slideToLoop(t);
        }),
        Shopify.designMode &&
          document.addEventListener("shopify:block:select", (e) =>
            this.onBlockSelect(e)
          );
    }
    onBlockSelect(e) {
      const t = e.target,
        i = Number(t.dataset.index);
      this.slider && this.slider.slideToLoop(i),
        this.imageSlider && this.imageSlider.slideToLoop(i);
    }
  }
  customElements.define("m-featured-slider", e);
}
if (!customElements.get("m-scrolling-promotion")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.promotion = this.querySelector(".m-promotion")), this.init();
    }
    init() {
      if (1 === this.childElementCount) {
        this.promotion.classList.add("m-promotion--animated");
        for (let e = 0; e < 10; e++)
          (this.clone = this.promotion.cloneNode(!0)),
            this.clone.setAttribute("aria-hidden", !0),
            this.appendChild(this.clone);
        new IntersectionObserver(
          (e, t) => {
            e.forEach((e) => {
              e.isIntersecting ? this.scrollingPlay() : this.scrollingPause();
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        ).observe(this);
      }
    }
    scrollingPlay() {
      this.classList.remove("m-scrolling-promotion--paused");
    }
    scrollingPause() {
      this.classList.add("m-scrolling-promotion--paused");
    }
  }
  customElements.define("m-scrolling-promotion", e);
}
if (!customElements.get("m-featured-collection")) {
  class MFeaturedCollection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        products: [".m-product-card"],
        soldNumber: ["[data-sold-number]"],
        countDown: "[data-flash-sale-countdown]",
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper", // slideContainer
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.paginationType = this.dataset.paginationType || "bullets";
      this.mobileLayout = this.dataset.mobileLayout;
      this.items = this.dataset.items;
      this.laptopItems = this.dataset.laptopItems;
      this.tabletItems = this.dataset.tabletItems;
      this.mobileItems = this.dataset.mobileItems || 2;

      this.initByScreenSize();
      document.addEventListener("matchMobile", () => {
        this.initByScreenSize();
      });
      document.addEventListener("unmatchMobile", () => {
        this.initByScreenSize();
      });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer, slideControls } = queryDomNodes(
        this.selectors,
        this
      );

      if (MinimogTheme.config.mqlMobile && this.mobileLayout !== "slider") {
        slideControls && slideControls.classList.add("m:hidden");
        slideContainer && slideContainer.classList.remove("swiper");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        slideControls && slideControls.classList.remove("m:hidden");
        this.initSlider();
      }
    }

    initSlider() {
      const { slideContainer, slideControls } = queryDomNodes(
        this.selectors,
        this
      );
      const prevButton =
        slideControls &&
        slideControls.querySelector(".m-slider-controls__button-prev");
      const nextButton =
        slideControls &&
        slideControls.querySelector(".m-slider-controls__button-next");

      slideContainer && slideContainer.classList.add("swiper");

      let __this = this;

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        modules: MinimogTheme.config.swiperModules,
        slidesPerView: parseInt(this.mobileItems),
        slidesPerGroup: 1,
        loop: this.enableFlashsale ? false : true,
        navigation: this.showNavigation
          ? {
              nextEl: nextButton,
              prevEl: prevButton,
            }
          : false,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              type: this.paginationType,
              clickable: true,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: this.tabletItems ? parseInt(this.tabletItems) : 3,
          },
          1024: {
            slidesPerView: this.laptopItems ? parseInt(this.laptopItems) : 4,
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        threshold: 2,
        on: {
          init: function () {
            setTimeout(() => {
              // Calculate controls position
              const firstCard = __this.querySelector(".m-product-card");
              const content = __this.querySelector(".m-section__content");

              if (firstCard && slideControls) {
                const firstImage =
                  firstCard.querySelector(".m-image") ||
                  firstCard.querySelector(".m-placeholder-svg");
                const prevButton = slideControls.querySelector(
                  ".m-slider-controls__button-prev"
                );
                const nextButton = slideControls.querySelector(
                  ".m-slider-controls__button-next"
                );
                const cardOffsetTop = window
                  .getComputedStyle(firstCard)
                  .getPropertyValue("padding-top");
                const buttonHeight = prevButton.offsetHeight;
                const itemHeight = firstImage.clientHeight;
                const contentHeight = content.clientHeight;

                slideControls.style.setProperty(
                  "--nav-offset-top",
                  parseInt(parseInt(contentHeight) / 7) * 3 + "px"
                );
                slideControls.style.setProperty(
                  "--nav-transform",
                  (-1 * parseInt(buttonHeight)) / 2 +
                    parseInt(cardOffsetTop) +
                    "px"
                );

                setTimeout(() => {
                  prevButton.classList.remove("m:opacity-0");
                  nextButton.classList.remove("m:opacity-0");
                }, 150);
              }
            }, 100);
          },
        },
      });

      this.swiper = slideContainer && slideContainer.swiper;
    }
  }

  customElements.define("m-featured-collection", MFeaturedCollection);
}
if (!customElements.get("m-banner-with-slide")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.lastActive = null), this.initSlider();
    }
    initSlider() {
      (this.slider = new MinimogLibs.Swiper(`.m-slider-${this.dataset.id}`, {
        modules: MinimogTheme.config.swiperModules,
        autoplay: "true" === this.dataset.autoplay && {
          delay: this.dataset.timeout,
          disableOnInteraction: !0,
        },
        slidesPerView: 1,
        fadeEffect: { crossFade: !0 },
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: !0,
          bulletClass: "m-dot",
          bulletActiveClass: "m-dot--active",
        },
        on: {
          init: function () {
            this.slideToLoop(this.lastActive);
          },
        },
      })),
        document.addEventListener("shopify:block:select", (e) =>
          this.onBlockSelect(e)
        );
    }
    onBlockSelect(e) {
      const t = e.target,
        i = Number(t.dataset.slide);
      (this.lastActive = i), this.slider && this.slider.slideToLoop(i);
    }
  }
  customElements.define("m-banner-with-slide", e);
}
if (!customElements.get("m-brand-list")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (!("true" === this.dataset.enableSlider)) return;
      const e = this.querySelector("[data-wrapper]");
      MinimogTheme.config.mqlMobile
        ? (e.classList.add("swiper-wrapper"), this.initSlider())
        : (e.classList.remove("swiper-wrapper"),
          this.slider && this.slider.destroy(!0, !0)),
        document.addEventListener("matchMobile", () => {
          e.classList.add("swiper-wrapper"), this.initSlider();
        }),
        document.addEventListener("unmatchMobile", () => {
          e.classList.remove("swiper-wrapper"),
            this.slider && this.slider.destroy(!0, !0);
        });
    }
    initSlider() {
      const e = "true" === this.dataset.enableAutoplay,
        t = this.dataset.autoplaySpeed,
        i = parseInt(this.dataset.items),
        s = this.querySelector(".swiper");
      s &&
        (this.slider = new MinimogLibs.Swiper(s, {
          modules: MinimogTheme.config.swiperModules,
          slidesPerView: i,
          slidesPerGroup: i,
          autoplay: !!e && { delay: 1e3 * parseInt(t) },
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: !0,
          },
        }));
    }
  }
  customElements.define("m-brand-list", e);
}
if (!customElements.get("m-custom-content")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.selectors = {
          bundleError: ".product-bundles__error",
          productBundles: [".product-bundles"],
          productVariantSelects: ".m-product-option--dropdown-select",
          totalPrice: "[data-total-price]",
          submitBundle: "[data-add-bundle]",
          errorWrapper: ".product-bundles__error",
          cartDrawer: "m-cart-drawer",
        }),
        (this.domNodes = queryDomNodes(this.selectors, this));
    }
    connectedCallback() {
      this.domNodes.productBundles && this.initProductBundles();
    }
    initProductBundles() {
      this.domNodes.productBundles.length &&
        this.domNodes.productBundles.map((e) => {
          let t = [],
            i = [];
          const s = e.querySelectorAll(".product-bundles__item");
          for (let e of s) {
            let s = e.nextElementSibling.innerHTML;
            (s = JSON.parse(s)),
              i.push(s),
              t.push(e),
              addEventDelegate({
                context: e,
                event: "change",
                selector: this.selectors.productVariantSelects,
                handler: (i) => this._handleChangePrice(i, e, s, t),
              });
          }
          addEventDelegate({
            context: e,
            selector: this.selectors.submitBundle,
            handler: (t) => this._handleAddItems(t, e),
          });
        });
    }
    _handleChangePrice(e, t, i, s) {
      const o = t.querySelector("[data-regular-price]");
      let n = t.querySelector("[data-compare-price]"),
        r = t.querySelector("[data-saved-price]"),
        a = t.querySelector(".product-bundles__save-price");
      const l = e.target.value,
        d = i.find((e) => e.id === parseInt(l));
      (o.innerHTML = formatMoney(d.price, MinimogSettings.money_format)),
        (o.dataset.price = d.price),
        d.compare_at_price && d.compare_at_price > d.price
          ? (n &&
              (n.classList.remove("m:hidden"),
              (n.innerHTML = formatMoney(
                d.compare_at_price,
                MinimogSettings.money_format
              ))),
            a && a.classList.remove("m:hidden"),
            r &&
              (r.classList.remove("m:hidden"),
              (r.innerHTML = formatMoney(
                d.compare_at_price - d.price,
                MinimogSettings.money_format
              ))))
          : (n && n.classList.add("m:hidden"),
            a && a.classList.add("m:hidden"),
            r && r.classList.add("m:hidden"));
      const c = s
          .map((e) => {
            let t = e.nextElementSibling.innerHTML;
            t = JSON.parse(t);
            let i = e.querySelector('[name="id"]');
            if (t && i) return t.find((e) => e.id === Number(i.value));
          })
          .filter(Boolean),
        h = c.reduce((e, t) => e + t.price, 0);
      t
        .closest(".product-bundles")
        .querySelector(this.selectors.totalPrice).innerHTML = formatMoney(
        h,
        MinimogSettings.money_format
      );
    }
    _handleAddItems(e, t) {
      e.preventDefault();
      const i = t.querySelectorAll('[name="id"]'),
        s = t.querySelector(this.selectors.errorWrapper),
        o = t.querySelector(this.selectors.submitBundle),
        n = document.querySelector(this.selectors.cartDrawer);
      let r = {
        items: [...i].map((e) => e.value).map((e) => ({ id: e, quantity: 1 })),
      };
      n &&
        (r = {
          ...r,
          sections: n.getSectionsToRender().map((e) => e.id),
          sections_url: window.location.pathname,
        });
      const a = fetchConfig("javascript");
      (a.method = "POST"),
        (a.body = JSON.stringify(r)),
        this._toggleLoading(!0, o);
      const { MinimogSettings: l, MinimogStrings: d } = window;
      fetch(`${l.routes.cart_add_url}`, a)
        .then((e) => e.json())
        .then((e) => {
          e.status
            ? this._showError(
                e.description || "Failed to add all items to cart!",
                s
              )
            : l.use_ajax_atc
            ? (l.enable_cart_drawer
                ? (n && n.renderContents(e),
                  MinimogTheme.Notification.show({
                    target: n.querySelector("m-cart-drawer-items"),
                    method: "prepend",
                    type: "success",
                    message: d.itemAdded,
                    delay: 400,
                  }))
                : window.MinimogTheme.Notification.show({
                    target: s || document.body,
                    method: "appendChild",
                    type: "success",
                    message: d.itemAdded,
                    last: 3e3,
                    sticky: !this.domNodes.errorWrapper,
                  }),
              window.MinimogEvents.emit(
                MinimogTheme.pubSubEvents.cartUpdate,
                e
              ))
            : (window.location = l.routes.cart);
        })
        .catch((e) => {})
        .finally(() => {
          if ((this._toggleLoading(!1, o), n)) {
            const e = n.querySelector("m-cart-drawer-items");
            n.classList.contains("m-cart--empty") &&
              n.classList.remove("m-cart--empty"),
              e &&
                e.classList.contains("m-cart--empty") &&
                e.classList.remove("m-cart--empty");
          }
        });
    }
    _showError(e, t) {
      MinimogTheme.Notification.show({
        target: t,
        method: "appendChild",
        type: "warning",
        message: e,
      });
    }
    _toggleLoading(e, t) {
      e
        ? t.classList.add("m-spinner-loading")
        : t.classList.remove("m-spinner-loading");
    }
  }
  customElements.define("m-custom-content", e);
}
if (!customElements.get("m-gmaps")) {
  class e extends HTMLElement {
    constructor() {
      super(), this.dataset.apiKey && this.dataset.mapAddress;
    }
    connectedCallback() {
      this.prepMapApi();
    }
    prepMapApi() {
      this.loadScript().then(this.initMap.bind(this));
    }
    loadScript() {
      return new Promise((e, t) => {
        const i = document.createElement("script");
        document.body.appendChild(i),
          (i.onload = e),
          (i.onerror = t),
          (i.async = !0),
          (i.src =
            "https://maps.googleapis.com/maps/api/js?key=" +
            this.dataset.apiKey);
      });
    }
    initMap() {
      new google.maps.Geocoder().geocode(
        { address: this.dataset.mapAddress },
        (e, t) => {
          if (t !== google.maps.GeocoderStatus.OK) Shopify.designMode;
          else {
            const t = {
                zoom: parseInt(this.dataset.zoom),
                center: e[0].geometry.location,
                draggable: !0,
                clickableIcons: !1,
                scrollwheel: !1,
                disableDoubleClickZoom: !0,
                disableDefaultUI: !0,
              },
              i = new google.maps.Map(this, t),
              s = i.getCenter();
            i.setCenter(s);
            const o = {
              path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
              fillColor: this.dataset.markerColor,
              fillOpacity: 1,
              anchor: new google.maps.Point(15, 55),
              strokeWeight: 0,
              scale: 0.6,
            };
            new google.maps.Marker({
              map: i,
              position: i.getCenter(),
              icon: o,
            });
            const n = new google.maps.StyledMapType(
              JSON.parse(
                this.parentNode.querySelector("[data-gmap-style]").innerHTML
              )
            );
            i.mapTypes.set("styled_map", n),
              i.setMapTypeId("styled_map"),
              google.maps.event.addDomListener(window, "resize", function () {
                google.maps.event.trigger(i, "resize"), i.setCenter(s);
              });
          }
        }
      );
    }
  }
  customElements.define("m-gmaps", e);
}
if (
  !customElements.get("m-countdown-timer") &&
  !customElements.get("m-countdown-timer")
) {
  class e extends HTMLElement {
    times = ["day", "hour", "min", "sec"];
    selectors = {
      day: "[data-timer-day]",
      hour: "[data-timer-hour]",
      min: "[data-timer-minute]",
      sec: "[data-timer-second]",
    };
    DAY_IN_MS = 864e5;
    HOUR_IN_MS = 36e5;
    MIN_IN_MS = 6e4;
    startTime = Date.now();
    constructor() {
      super();
    }
    connectedCallback() {
      this.dataset.countdownTimer && this.init();
    }
    init = () => {
      (this.startTime = Date.now()),
        (this.savedStartTime = this.startTime),
        (this.endTime = new Date(this.dataset.countdownTimer).getTime()),
        (this.options = { addZeroPrefix: !0, loop: !1, callback: () => {} }),
        this.endTime < this.startTime ||
          ((this.intervalTime = 1e3),
          (this.timer = null),
          (this.domNodes = queryDomNodes(this.selectors, this)),
          (this.wrapper = this.closest(this.selectors.wrapper)),
          this.start());
    };
    start = () => {
      (this.timer = setInterval(() => {
        this.startTime > this.endTime ? this.stop() : this.update();
      }, this.intervalTime)),
        this.classList.remove("m:hidden");
    };
    update = () => {
      const e = this.format(this.endTime - this.startTime);
      this.times.forEach((t) => {
        this.domNodes[t] &&
          (this.domNodes[t].textContent = this.addZeroPrefix(e[t]));
      }),
        (this.startTime += this.intervalTime);
    };
    stop = () => {
      clearInterval(this.timer),
        this.options.loop
          ? ((this.startTime = this.savedStartTime), this.start())
          : ((this.timer = null),
            this.options.callback(),
            this.classList.add("f-hidden"),
            this.wrapper && this.wrapper.setAttribute("hidden", !0));
    };
    clear = () => {
      clearInterval(this.timer),
        (this.timer = null),
        (this.startTime = this.savedStartTime),
        this.times.forEach((e) => {
          this.domNodes[e] && (this.domNodes[e].textContent = "00");
        });
    };
    addZeroPrefix = (e) =>
      this.options.addZeroPrefix && e < 10 ? `0${e}` : e.toString();
    format = (e) => ({
      day: Math.floor(e / this.DAY_IN_MS),
      hour: Math.floor(e / this.HOUR_IN_MS) % 24,
      min: Math.floor(e / this.MIN_IN_MS) % 60,
      sec: Math.floor(e / 1e3) % 60,
    });
  }
  customElements.define("m-countdown-timer", e);
}
if (!customElements.get("m-image-comparison")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.active = !1),
        (this.button = this.querySelector("button")),
        (this.horizontal = "horizontal" === this.dataset.layout),
        this.init(),
        this.hasAttribute("data-animation") &&
          MinimogTheme.initWhenVisible({
            element: this.querySelector(
              ".m-image-comparison__slider-animation"
            ),
            callback: this.animation.bind(this),
            threshold: 0,
          });
    }
    init() {
      this.button.addEventListener("touchstart", this.start.bind(this)),
        document.body.addEventListener("touchend", this.end.bind(this)),
        document.body.addEventListener("touchmove", this.onStart.bind(this)),
        this.button.addEventListener("mousedown", this.start.bind(this)),
        document.body.addEventListener("mouseup", this.end.bind(this)),
        document.body.addEventListener("mousemove", this.onStart.bind(this));
    }
    animation() {
      this.setAttribute("is-visible", ""),
        this.classList.add("m-animating"),
        setTimeout(() => {
          this.classList.remove("m-animating");
        }, 1e3);
    }
    start() {
      const e = getScrollbarWidth();
      document.body.style.setProperty("padding-right", e + "px"),
        document.documentElement.style.setProperty("overflow", "hidden"),
        (this.active = !0),
        this.classList.add("image-comparing");
    }
    end() {
      document.body.style.setProperty("padding-right", 0),
        document.documentElement.style.removeProperty("overflow"),
        (this.active = !1),
        this.classList.remove("image-comparing");
    }
    onStart(e) {
      const t = document.querySelector(".m-topbar"),
        i = document.querySelector(".m-announcement-bar");
      let s = 0,
        o = 0;
      if ((t && (s = t.offsetHeight), i && (o = i.offsetHeight), !this.active))
        return;
      const n = (e.touches && e.touches[0]) || e,
        r = this.horizontal
          ? n.pageX - this.offsetLeft
          : n.pageY - this.offsetTop - s - o;
      this.scroll(r);
    }
    scroll(e) {
      const t = this.horizontal ? this.clientWidth : this.clientHeight,
        i = t - 20,
        s = (100 * Math.max(20, Math.min(e, i))) / t;
      this.style.setProperty("--percent", s + "%");
    }
  }
  customElements.define("m-image-comparison", e);
}
if (!customElements.get("m-video-component")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.init();
    }
    init() {
      switch (
        ((this.parentSelector = this.dataset.parent || ".m-video-hero__bg"),
        (this.parent = this.closest(this.parentSelector)),
        this.dataset.type)
      ) {
        case "youtube":
          this.initYoutubeVideo();
          break;
        case "vimeo":
          this.initVimeoVideo();
          break;
        case "mp4":
          this.initMp4Video();
      }
    }
    initYoutubeVideo() {
      this.setAsLoading(),
        this.loadScript("youtube").then(this.setupYoutubePlayer.bind(this));
    }
    initVimeoVideo() {
      this.setAsLoading(),
        this.loadScript("vimeo").then(this.setupVimeoPlayer.bind(this));
    }
    initMp4Video() {
      const e = this.querySelector("video");
      if (e) {
        const t = e.play();
        void 0 !== t &&
          t
            .then(function () {})
            .catch(function () {
              e.setAttribute("controls", "");
            });
      }
    }
    loadScript(e) {
      return new Promise((t, i) => {
        const s = document.createElement("script");
        document.body.appendChild(s),
          (s.onload = t),
          (s.onerror = i),
          (s.async = !0),
          (s.src =
            "youtube" === e
              ? "//www.youtube.com/iframe_api"
              : "//player.vimeo.com/api/player.js");
      });
    }
    setAsLoading() {
      this.parent.setAttribute("loading", !0);
    }
    setAsLoaded() {
      this.parent.removeAttribute("loading"),
        this.parent.setAttribute("loaded", !0);
    }
    setupYoutubePlayer() {
      const e = this.dataset.videoId,
        t = setInterval(() => {
          window.YT &&
            window.YT.ready(() => {
              const i = document.createElement("div");
              this.appendChild(i),
                (this.player = new YT.Player(i, {
                  videoId: e,
                  playerVars: {
                    showinfo: 0,
                    controls: !1,
                    fs: 0,
                    rel: 0,
                    height: "100%",
                    width: "100%",
                    iv_load_policy: 3,
                    html5: 1,
                    loop: 1,
                    playsinline: 1,
                    modestbranding: 1,
                    disablekb: 1,
                  },
                  events: {
                    onReady: this.onYoutubeReady.bind(this),
                    onStateChange: this.onYoutubeStateChange.bind(this),
                  },
                })),
                clearInterval(t);
            });
        }, 50);
    }
    onYoutubeReady() {
      if (
        ((this.iframe = this.querySelector("iframe")),
        this.iframe.setAttribute("tabindex", "-1"),
        this.player && this.player.mute(),
        "function" == typeof this.player.playVideo && this.player.playVideo(),
        this.setAsLoaded(),
        "IntersectionObserver" in window)
      ) {
        new IntersectionObserver(
          (e, t) => {
            e.forEach((e) => {
              e.isIntersecting ? this.youtubePlay() : this.youtubePause();
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        ).observe(this.iframe);
      }
    }
    onYoutubeStateChange(e) {
      switch (e.data) {
        case -1:
          this.attemptedToPlay && this.setAsLoaded();
          break;
        case 0:
          this.youtubePlay();
          break;
        case 1:
          this.setAsLoaded();
          break;
        case 3:
          this.attemptedToPlay = !0;
      }
    }
    youtubePlay() {
      this.player &&
        "function" == typeof this.player.playVideo &&
        this.player.playVideo();
    }
    youtubePause() {
      this.player &&
        "function" == typeof this.player.pauseVideo &&
        this.player.pauseVideo();
    }
    setupVimeoPlayer() {
      const e = this.dataset.videoId,
        t = setInterval(() => {
          window.Vimeo &&
            ((this.player = new Vimeo.Player(this, {
              id: e,
              autoplay: !0,
              autopause: !1,
              background: !1,
              controls: !1,
              loop: !0,
              height: "100%",
              width: "100%",
            })),
            this.player.ready().then(this.onVimeoReady.bind(this)),
            clearInterval(t));
        }, 50);
    }
    onVimeoReady() {
      (this.iframe = this.querySelector("iframe")),
        this.iframe.setAttribute("tabindex", "-1"),
        this.player.setMuted(!0),
        this.setAsLoaded();
      new IntersectionObserver(
        (e, t) => {
          e.forEach((e) => {
            e.isIntersecting ? this.vimeoPlay() : this.vimeoPause();
          });
        },
        { rootMargin: "0px 0px 50px 0px" }
      ).observe(this.iframe);
    }
    vimeoPlay() {
      this.player &&
        "function" == typeof this.player.play &&
        this.player.play();
    }
    vimeoPause() {
      this.player &&
        "function" == typeof this.player.pause &&
        this.player.pause();
    }
  }
  customElements.define("m-video-component", e);
}
if (!customElements.get("m-search-popup")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.selectors = {
          container: "[data-search-container]",
          form: "form",
          input: "[data-search-input]",
          submit: 'button[type="submit"]',
          loading: "[data-spinner]",
          close: "[data-close-search]",
        });
      const e = document.querySelector("[data-search-popup]");
      if (!e) return;
      (this.domNodes = queryDomNodes(this.selectors, e)),
        (this.domNodes.searchPopup = e),
        document.body.appendChild(e),
        addEventDelegate({
          selector: "[data-open-search-popup]",
          handler: () => this.openSearchPopup(),
        });
      const { input: t, submit: i, close: s, form: o } = this.domNodes;
      t &&
        t.addEventListener("keydown", (e) => {
          27 === e.keyCode && this.closeSearchPopup();
        }),
        i.addEventListener("click", (e) => {
          e.preventDefault(), t.value && o.submit();
        }),
        s.addEventListener("click", (e) => {
          this.closeSearchPopup();
        }),
        e.addEventListener("click", (t) => {
          t.target === e && this.closeSearchPopup();
        }),
        MinimogEvents.subscribe(
          MinimogTheme.pubSubEvents.openCartDrawer,
          () => {
            this.closeSearchPopup();
          }
        );
    }
    openSearchPopup() {
      const { searchPopup: e, input: t, container: i } = this.domNodes;
      e.style.removeProperty("visibility"),
        e.style.setProperty("opacity", "1"),
        i.classList.add("m-show-search"),
        setTimeout(() => {
          i.classList.remove("duration-300"),
            i.style.removeProperty("--m-durations"),
            t.focus();
        }, 350),
        MinimogEvents.emit(MinimogTheme.pubSubEvents.openSearchPopup, this);
    }
    closeSearchPopup() {
      const { searchPopup: e, container: t } = this.domNodes;
      t.classList.remove("m-show-search"),
        e.style.setProperty("opacity", "0"),
        setTimeout(() => {
          e.style.setProperty("visibility", "hidden"),
            t.style.setProperty("--m-durations", ".3s");
        }, 350);
    }
  }
  customElements.define("m-search-popup", e);
}
if (!customElements.get("m-icon-box")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.enableSlider = "true" === this.dataset.enableSlider),
        (this.items = this.dataset.items),
        (this.showPagination = "true" === this.dataset.showPagination),
        (this.showNavigation = "true" === this.dataset.showNavigation),
        (this.slideContainer = this.querySelector(".swiper"));
    }
    connectedCallback() {
      (this.lastActive = null), this.enableSlider && this.initSlider();
    }
    initSlider() {
      const e = this.querySelector(".m-slider-controls"),
        t = e && e.querySelector(".m-slider-controls__button-prev"),
        i = e && e.querySelector(".m-slider-controls__button-next"),
        s = this.querySelector(".swiper-wrapper").childElementCount;
      let o = this;
      (this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        modules: MinimogTheme.config.swiperModules,
        slidesPerView: 1,
        navigation: this.showNavigation,
        pagination: !!this.showPagination && {
          el: this.querySelector(".swiper-pagination"),
          clickable: !0,
        },
        breakpoints: {
          480: { slidesPerView: 2 },
          768: { slidesPerView: parseInt(this.items) - 1 },
          1280: { slidesPerView: parseInt(this.items) },
        },
        on: {
          init: function () {
            this.slideToLoop(this.lastActive),
              setTimeout(() => {
                const s = o.querySelector(".m-image");
                if (s && e) {
                  const o = s.clientHeight;
                  e.style.setProperty("--offset-top", parseInt(o) / 2 + "px"),
                    t.classList.remove("m:hidden"),
                    i.classList.remove("m:hidden");
                }
              }, 200);
          },
          breakpoint: (t, i) => {
            if (e) {
              const { slidesPerView: o } = i;
              s > o
                ? (e.classList.remove("m:hidden"), (t.allowTouchMove = !0))
                : (e.classList.add("m:hidden"), (t.allowTouchMove = !1));
            }
          },
        },
      })),
        this.slider &&
          this.showNavigation &&
          (t && t.addEventListener("click", () => this.slider.slidePrev()),
          i && i.addEventListener("click", () => this.slider.slideNext())),
        document.addEventListener("shopify:block:select", (e) =>
          this.onBlockSelect(e)
        );
    }
    onBlockSelect(e) {
      const t = e.target,
        i = Number(t.dataset.slide);
      (this.lastActive = i), this.slider && this.slider.slideToLoop(i);
    }
  }
  customElements.define("m-icon-box", e);
}
if (!customElements.get("m-handpicked-products")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.selectors = {
        products: [".m-product-card"],
        slideContainer: ".m-mixed-layout__wrapper",
        slideControls: ".m-slider-controls",
      }),
        (this.domNodes = queryDomNodes(this.selectors, this)),
        (this.enableSlider = "true" === this.dataset.enableSlider),
        (this.showPagination = "true" === this.dataset.showPagination),
        (this.showNavigation = "true" === this.dataset.showNavigation),
        (this.paginationType = this.dataset.paginationType || "bullets"),
        (this.mobileLayout = this.dataset.mobileLayout),
        (this.items = this.dataset.items),
        (this.laptopItems = this.dataset.laptopItems),
        (this.tabletItems = this.dataset.tabletItems),
        (this.mobileItems = this.dataset.mobileItems || 2),
        this.initByScreenSize(),
        document.addEventListener("matchMobile", () => {
          this.initByScreenSize();
        }),
        document.addEventListener("unmatchMobile", () => {
          this.initByScreenSize();
        });
    }
    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer: e, slideControls: t } = queryDomNodes(
        this.selectors,
        this
      );
      MinimogTheme.config.mqlMobile && "slider" !== this.mobileLayout
        ? (t && t.classList.add("m:hidden"),
          e && e.classList.remove("swiper"),
          this.swiper && this.swiper.destroy(!1, !0))
        : (t && t.classList.remove("m:hidden"), this.initSlider());
    }
    initSlider() {
      const { slideContainer: e, slideControls: t } = queryDomNodes(
          this.selectors,
          this
        ),
        i = t && t.querySelector(".m-slider-controls__button-prev"),
        s = t && t.querySelector(".m-slider-controls__button-next");
      e && e.classList.add("swiper");
      let o = this;
      (this.slider = new MinimogLibs.Swiper(e, {
        modules: MinimogTheme.config.swiperModules,
        slidesPerView: parseInt(this.mobileItems),
        slidesPerGroup: 1,
        loop: !1,
        navigation: !!this.showNavigation && { nextEl: s, prevEl: i },
        pagination: !!this.showPagination && {
          el: this.querySelector(".swiper-pagination"),
          type: this.paginationType,
          clickable: !0,
        },
        breakpoints: {
          768: {
            slidesPerView: this.tabletItems ? parseInt(this.tabletItems) : 3,
          },
          1024: {
            slidesPerView: this.laptopItems ? parseInt(this.laptopItems) : 4,
          },
          1280: { slidesPerView: parseInt(this.items) },
        },
        threshold: 2,
        on: {
          init: function () {
            setTimeout(() => {
              const e = o.querySelector(".m-product-card");
              if (e && t) {
                const i = e.querySelector(".m-image"),
                  s = t.querySelector(".m-slider-controls__button-prev"),
                  o = t.querySelector(".m-slider-controls__button-next"),
                  n = window
                    .getComputedStyle(e)
                    .getPropertyValue("padding-top"),
                  r = s.offsetHeight,
                  a = i.clientHeight;
                t.style.setProperty("--nav-offset-top", parseInt(a) / 2 + "px"),
                  t.style.setProperty(
                    "--nav-transform",
                    (-1 * parseInt(r)) / 2 + parseInt(n) + "px"
                  ),
                  setTimeout(() => {
                    s.classList.remove("m:opacity-0"),
                      o.classList.remove("m:opacity-0");
                  }, 150);
              }
            }, 100);
          },
        },
      })),
        (this.swiper = e && e.swiper);
    }
  }
  customElements.define("m-handpicked-products", e);
}
if (!customElements.get("m-lookbook-slider")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.selectors = {
        lookbookSlider: ".m-lookbook-slider__inner",
        lookbookIcons: [".m-lookbook-icon"],
      }),
        (this.domNodes = queryDomNodes(this.selectors, this)),
        (this.enableSlider =
          "true" === this.domNodes.lookbookSlider.dataset.enableSlider),
        (this.showPagination =
          "true" === this.domNodes.lookbookSlider.dataset.showPagination),
        (this.showNavigation =
          "true" === this.domNodes.lookbookSlider.dataset.showNavigation),
        (this.paginationType =
          this.domNodes.lookbookSlider.dataset.paginationType || "bullets"),
        (this.items = this.domNodes.lookbookSlider.dataset.items),
        (this.slideContainer =
          this.domNodes.lookbookSlider.querySelector(".swiper")),
        this.enableSlider && this.initSlider(),
        Array.from(this.domNodes.lookbookIcons).forEach((e) => {
          e.addEventListener("mouseover", this.onMouseOver.bind(this)),
            e.addEventListener("mouseleave", this.onMouseLeave.bind(this));
        });
    }
    disconnectedCallback() {
      Array.from(this.domNodes.lookbookIcons).forEach((e) => {
        e.removeEventListener("mouseover", this.onMouseOver.bind(this)),
          e.removeEventListener("mouseleave", this.onMouseLeave.bind(this));
      });
    }
    initSlider() {
      const e =
          this.domNodes.lookbookSlider.querySelector(".m-slider-controls"),
        t = e && e.querySelector(".m-slider-controls__button-prev"),
        i = e && e.querySelector(".m-slider-controls__button-next"),
        s =
          this.slideContainer.querySelector(
            ".swiper-wrapper"
          ).childElementCount;
      let o = {
        modules: MinimogTheme.config.swiperModules,
        slidesPerView: 1,
        showPagination: this.showPagination,
        showNavigation: this.showNavigation,
        loop: !0,
        pagination: !!this.showPagination && {
          el: this.domNodes.lookbookSlider.querySelector(".swiper-pagination"),
          clickable: !0,
          type: this.paginationType,
        },
        breakpoints: {
          1280: { slidesPerView: s < this.items ? s : parseInt(this.items) },
        },
        threshold: 2,
        on: {
          slideChange: (e) => {
            const t = e.realIndex;
            Array.from(this.domNodes.lookbookIcons).forEach((e) =>
              e.classList.remove("is-active")
            ),
              this.domNodes.lookbookIcons[t] &&
                this.domNodes.lookbookIcons[t].classList.add("is-active");
          },
        },
      };
      s < this.items && ((o.simulateTouch = !1), (o.allowTouchMove = !1)),
        (this.slider = new MinimogLibs.Swiper(this.slideContainer, o)),
        this.slider &&
          this.showNavigation &&
          (t && t.addEventListener("click", () => this.slider.slidePrev()),
          i && i.addEventListener("click", () => this.slider.slideNext()));
    }
    onMouseOver(e) {
      const t = Number(e.target.closest(".m-lookbook-icon").dataset.index);
      e.target.dataset.index && this.slider && this.slider.slideToLoop(t);
      const i = this.domNodes.lookbookSlider.querySelectorAll(
        `[data-swiper-slide-index="${t}"]`
      );
      Array.from(i).forEach((e) =>
        e.querySelector(".m-product-card").classList.add("is-active")
      ),
        this.domNodes.lookbookIcons[t].classList.add("is-active"),
        this.classList.add("is-hovering");
    }
    onMouseLeave(e) {
      Array.from(this.slider.slides).forEach((e) =>
        e.querySelector(".m-product-card").classList.remove("is-active")
      ),
        Array.from(this.domNodes.lookbookIcons).forEach((e) =>
          e.classList.remove("is-active")
        ),
        this.classList.remove("is-hovering");
    }
  }
  customElements.define("m-lookbook-slider", e);
}
if (!customElements.get("favorite-product-slider")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.selectors = {
        mainImages: ".m-favorite-product-slider__images",
        thumbs: ".m-favorite-product-slider__thumbs",
      }),
        (this.domNodes = queryDomNodes(this.selectors, this)),
        (this.mediaSize = parseInt(this.dataset.mediaSize)),
        (this.mainImagesContainer =
          this.domNodes.mainImages.querySelector(".swiper")),
        (this.thumbsContainer = this.domNodes.thumbs.querySelector(".swiper")),
        (this.spacingDesktop = this.dataset.spacingDesktop || 30),
        (this.spacingMobile = this.dataset.spacingMobile || 15),
        this.initSlider();
    }
    initSlider() {
      this.initMainImagesSlider(),
        this.initThumbsSlider(),
        this.thumbsSlider.on("slideChange", (e) => {
          const { realIndex: t } = e;
          let i = t - 1;
          i < 0 && (i = this.mediaSize - 1),
            this.mainImagesSlider.slideToLoop(i);
        }),
        this.mainImagesSlider.on("slideChange", (e) => {
          const { slides: t, realIndex: i } = e;
          let s = i + 1;
          s > this.mediaSize && (s = 0), this.playActiveMedia(t[s]);
        });
    }
    initMainImagesSlider() {
      const e = this.domNodes.mainImages.querySelector(".m-slider-controls"),
        t = e && e.querySelector(".m-slider-controls__button-prev"),
        i = e && e.querySelector(".m-slider-controls__button-next");
      this.mainImagesSlider = new MinimogLibs.Swiper(this.mainImagesContainer, {
        modules: [
          MinimogLibs.Swiper.Navigation,
          MinimogLibs.Swiper.Pagination,
          MinimogLibs.Swiper.Thumbs,
        ],
        slidesPerView: 1,
        loop: !0,
        navigation: { nextEl: i, prevEl: t },
        pagination: {
          el: this.domNodes.mainImages.querySelector(".swiper-pagination"),
          clickable: !0,
          type: "fraction",
        },
        autoplay: !1,
        threshold: 2,
        effect: "fade",
        fadeEffect: { crossFade: !0 },
        breakpoints: {
          768: {
            simulateTouch: !1,
            allowTouchMove: !1,
            showPagination: !1,
            showNavigation: !1,
          },
        },
        simulateTouch: !0,
        allowTouchMove: !0,
      });
    }
    initThumbsSlider() {
      const e = this.domNodes.thumbs.querySelector(".m-slider-controls"),
        t = e && e.querySelector(".m-slider-controls__button-prev"),
        i = e && e.querySelector(".m-slider-controls__button-next"),
        s =
          this.domNodes.thumbs.querySelector(
            ".swiper-wrapper"
          ).childElementCount;
      this.thumbsSlider = new MinimogLibs.Swiper(this.thumbsContainer, {
        modules: [
          MinimogLibs.Swiper.Navigation,
          MinimogLibs.Swiper.Pagination,
          MinimogLibs.Swiper.Thumbs,
        ],
        initialSlide: s > 1 ? 1 : 0,
        slidesPerView: 2 == s ? 1 : 2,
        loop: !0,
        navigation: { nextEl: i, prevEl: t },
        autoplay: !1,
        pagination: {
          el: this.domNodes.thumbs.querySelector(".swiper-pagination"),
          clickable: !0,
          type: "fraction",
        },
        spaceBetween: parseInt(this.spacingMobile),
        breakpoints: { 1024: { spaceBetween: parseInt(this.spacingDesktop) } },
        threshold: 2,
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });
    }
    playActiveMedia(e) {
      const t = e.querySelector(".deferred-media");
      if (t) {
        "true" === t.dataset.autoPlay && t.loadContent(!1);
      }
    }
  }
  customElements.define("favorite-product-slider", e);
}
if (!customElements.get("m-select-component")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.selectors = {
          elSelectNative: ".js-selectNative",
          elSelectCustom: ".js-selectCustom",
          elSelectCustomBox: ".m-select-custom--trigger",
          elSelectCustomOpts: ".m-select-custom--options",
          elSelectCustomTriggerText: ".m-select-custom--trigger-text",
          customOptionList: [".m-select-custom--option"],
        }),
        (this.domNodes = queryDomNodes(this.selectors, this)),
        (this.optionChecked = ""),
        (this.reversedCssClass = "m-select-custom--reversed"),
        window.addEventListener("DOMContentLoaded", () => {
          this.classList.remove("m:hidden");
        }),
        this.setDefaultValue(),
        this.initSelect();
    }
    setDefaultValue() {
      const { elSelectNative: e } = this.domNodes,
        t = e.options[e.selectedIndex].value,
        i = e.options[e.selectedIndex].text;
      this.updateCustomSelectChecked(t, i);
    }
    initSelect() {
      this.classList.remove("m:hidden");
      const {
        elSelectNative: e,
        elSelectCustom: t,
        elSelectCustomBox: i,
      } = this.domNodes;
      i.addEventListener("click", () => {
        !t.classList.contains("isActive")
          ? this.openSelect()
          : this.closeSelect();
      }),
        this.domNodes.customOptionList.forEach((t) => {
          t.addEventListener("click", (t) => {
            const i = t.target.getAttribute("data-value");
            this.closeSelect(),
              i != e.value &&
                ((e.value = i),
                this.closeSelect(),
                this.updateCustomSelectChecked(i, t.target.textContent),
                e.dispatchEvent(new Event("change"))),
              e.dispatchEvent(new Event("click"));
          });
        });
    }
    openSelect() {
      const e = document.querySelectorAll("m-select-component");
      document.addEventListener("click", (e) => this.handleClickOutside(e)),
        e.length > 0 &&
          e.forEach((e) => {
            e.closeSelect();
          }),
        this.domNodes.elSelectCustom.classList.remove(this.reversedCssClass),
        document.documentElement.clientWidth <
          this.offsetLeft + this.domNodes.elSelectCustomOpts.offsetWidth + 10 &&
          this.domNodes.elSelectCustom.classList.add(this.reversedCssClass),
        this.domNodes.elSelectCustom.classList.add("isActive");
    }
    closeSelect() {
      this.domNodes.elSelectCustom.classList.remove("isActive");
    }
    updateCustomSelectChecked(e, t) {
      const { elSelectCustomOpts: i, elSelectCustomTriggerText: s } =
          this.domNodes,
        o = this.optionChecked,
        n = i.querySelector(`[data-value="${o}"`),
        r = i.querySelector(`[data-value="${e}"`);
      n && n.classList.remove("isActive"),
        r && r.classList.add("isActive"),
        (s.textContent = t),
        (this.optionChecked = e);
    }
    handleClickOutside(e) {
      const { elSelectCustom: t } = this.domNodes;
      !t.contains(e.target) && this.closeSelect();
    }
  }
  customElements.define("m-select-component", e);
}
if (!customElements.get("m-product-details-tabs")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.tabs = new MinimogTheme.Tabs(this)),
        (this.acc = new MinimogLibs.Accordion(this, {
          presetContentHeight: !0,
          onload: !0,
        })),
        Shopify.designMode &&
          (document.addEventListener("shopify:block:select", (e) => {
            const t = e && e.target,
              i = (t && Number(t.dataset.index)) || 0;
            if (this.acc) {
              const e = this.acc.domNodes.items[i];
              (e && e.classList.contains("open")) ||
                (this.acc && this.acc.toggle(i));
            }
            this.tabs && this.tabs.setActiveTab(i);
          }),
          document.addEventListener("shopify:block:deselect", (e) => {
            const t = e && e.target,
              i = (t && Number(t.dataset.index)) || 0;
            if (this.acc) {
              const e = this.acc.domNodes.items[i];
              e &&
                e.classList.contains("open") &&
                this.acc &&
                this.acc.toggle(i);
            }
          }));
    }
  }
  customElements.define("m-product-details-tabs", e);
}
if (!customElements.get("m-instagram")) {
  class e extends HTMLElement {
    constructor() {
      super(), this.init();
    }
    init() {
      const { MinimogThemeScripts: e } = window,
        { accessToken: t, imagesCount: i } = this.dataset;
      t &&
        loadAssets([e.instagram], "instagram-module", () => {
          new MinimogTheme.Instagram(this, t, i);
        });
    }
  }
  customElements.define("m-instagram", e);
}
if (!customElements.get("m-aside-instagram")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const e = this.querySelector(".m-aside-instagram");
      if (e) {
        const { accessToken: t, imagesCount: i } = e.dataset;
        if (t) {
          const { MinimogThemeScripts: s } = window;
          loadAssets([s.instagram], "instagram-module-blog", () => {
            new MinimogTheme.Instagram(e, t, i);
          });
        }
      }
    }
  }
  customElements.define("m-aside-instagram", e);
}
class MQuantityInput extends HTMLElement {
  constructor() {
    super(), this.init();
  }
  init() {
    (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.input.addEventListener("change", this.onInputChange.bind(this)),
      this.querySelectorAll("button").forEach((e) =>
        e.addEventListener("click", this.onButtonClick.bind(this))
      ),
      (this.quantityUpdateUnsubscriber = void 0);
  }
  onInputChange(e) {
    this.validateQtyRules();
  }
  onButtonClick(e) {
    e.preventDefault();
    const t = this.input.value;
    "plus" === e.target.closest("button").name
      ? this.input.stepUp()
      : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const e = parseInt(this.input.value);
    if (this.input.min) {
      const t = parseInt(this.input.min);
      this.querySelector(".m-quantity__button[name='minus']").classList.toggle(
        "m:disabled",
        e <= t
      );
    }
    if (this.input.max) {
      const t = parseInt(this.input.max);
      this.querySelector(".m-quantity__button[name='plus']").classList.toggle(
        "m:disabled",
        e >= t
      );
    }
  }
}
customElements.define("m-quantity-input", MQuantityInput);
class MTabsComponent extends HTMLElement {
  constructor() {
    super(),
      (this.KEYCODE = {
        DOWN: 40,
        LEFT: 37,
        RIGHT: 39,
        UP: 38,
        HOME: 36,
        END: 35,
      });
  }
  connectedCallback() {
    this.addEventListener("click", this.onclick),
      this.addEventListener("keydown", this.onKeydown),
      this.hasAttribute("role") || this.setAttribute("role", "tablist"),
      Promise.all([
        customElements.whenDefined("m-tab-header"),
        customElements.whenDefined("m-tab-content"),
      ]).then(() => {
        this.linkPanels();
      });
  }
  linkPanels() {
    const e = this.allTabs();
    e.forEach((e) => {
      const t = this.querySelector(`#panel-${e.id}`);
      e.setAttribute("aria-controls", t.id),
        t.setAttribute("aria-labelledby", e.id);
    });
    const t = e.find((e) => e.selected) || e[0];
    this.selectTab(t);
  }
  allTabs() {
    return Array.from(this.querySelectorAll("m-tab-header"));
  }
  allPanels() {
    return Array.from(this.querySelectorAll("m-tab-content"));
  }
  reset() {
    const e = this.allTabs(),
      t = this.allPanels();
    e.forEach((e) => (e.selected = !1)), t.forEach((e) => (e.hidden = !0));
  }
  panelForTab(e) {
    const t = e.getAttribute("aria-controls");
    return this.querySelector(`#${t}`);
  }
  prevTab() {
    const e = this.allTabs();
    let t = e.findIndex((e) => e.selected) - 1;
    return e[(t + e.length) % e.length];
  }
  firstTab() {
    return this.allTabs()[0];
  }
  lastTab() {
    const e = this.allTabs();
    return e[e.length - 1];
  }
  nextTab() {
    const e = this.allTabs();
    let t = e.findIndex((e) => e.selected) + 1;
    return e[t % e.length];
  }
  selectTab(e) {
    this.reset();
    const t = this.panelForTab(e);
    if (!t) throw new Error(`No panel with id ${newPanelId}`);
    (e.selected = !0), (t.hidden = !1);
  }
  onclick(e) {
    "tab" === e.target.getAttribute("role") && this.selectTab(e.target);
  }
  onKeydown(e) {
    if ("tab" !== e.target.getAttribute("role")) return;
    if (e.altKey) return;
    let t;
    switch (e.keyCode) {
      case this.KEYCODE.LEFT:
      case this.KEYCODE.UP:
        t = this.prevTab();
        break;
      case this.KEYCODE.RIGHT:
      case this.KEYCODE.DOWN:
        t = this.nextTab();
        break;
      case this.KEYCODE.HOME:
        t = this.firstTab();
        break;
      case this.KEYCODE.END:
        t = this.lastTab();
        break;
      default:
        return;
    }
    e.preventDefault(), this.selectTab(t);
  }
}
customElements.define("m-tabs-component", MTabsComponent);
class MTabHeader extends HTMLElement {
  static get observedAttributes() {
    return ["selected"];
  }
  constructor() {
    super();
  }
  connectedCallback() {
    this.setAttribute("role", "tab"),
      this.setAttribute("aria-selected", "false"),
      this.setAttribute("tabindex", -1),
      this.upgradeProperty("selected");
  }
  upgradeProperty(e) {
    if (this.hasOwnProperty(e)) {
      let t = this[e];
      delete this[e], (this[e] = t);
    }
  }
  attributeChangedCallback() {
    const e = this.hasAttribute("selected");
    this.setAttribute("aria-selected", e),
      this.setAttribute("tabindex", e ? 0 : -1);
  }
  set selected(e) {
    (e = Boolean(e))
      ? this.setAttribute("selected", "")
      : this.removeAttribute("selected");
  }
  get selected() {
    return this.hasAttribute("selected");
  }
}
customElements.define("m-tab-header", MTabHeader);
class MTabContent extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.setAttribute("role", "tabpanel");
  }
}
customElements.define("m-tab-content", MTabContent);
class MenuDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.mainDetailsToggle = this.querySelector(
        "[data-main-details-toggle]"
      )),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("[data-summary-button]").forEach((e) =>
      e.addEventListener("click", this.onSummaryClick.bind(this))
    ),
      this.querySelectorAll(".m-menu-drawer__close-button").forEach((e) => {
        e.addEventListener("click", this.onCloseButtonClick.bind(this));
      });
  }
  onKeyUp(e) {
    if ("ESCAPE" !== e.code.toUpperCase()) return;
    const t = e.target.closest("[data-main-details-toggle][open]");
    t &&
      (t === this.mainDetailsToggle
        ? this.closeMenuDrawer(
            e,
            this.mainDetailsToggle.querySelector("[data-summary-button]")
          )
        : this.closeSubmenu(t));
  }
  onSummaryClick(e) {
    e.preventDefault();
    const t = e.currentTarget,
      i = t.closest("[data-main-details-toggle]"),
      s = i.closest(".m-has-submenu"),
      o = i.hasAttribute("open"),
      n = window.matchMedia("(prefers-reduced-motion: reduce)");
    function r() {
      trapFocus(t.nextElementSibling, i.querySelector("button")),
        t.nextElementSibling.removeEventListener("transitionend", r);
    }
    i === this.mainDetailsToggle
      ? (o && e.preventDefault(),
        o ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t),
        window.matchMedia("(max-width: 1280px)") &&
          document.documentElement.style.setProperty(
            "--viewport-height",
            `${window.innerHeight}px`
          ))
      : setTimeout(() => {
          i.classList.add("menu-opening"),
            i.setAttribute("open", ""),
            t.setAttribute("aria-expanded", !0),
            s && s.classList.add("submenu-open"),
            !n || n.matches
              ? r()
              : t.nextElementSibling.addEventListener("transitionend", r);
        }, 100);
  }
  openMenuDrawer(e) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      e.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, e);
  }
  closeMenuDrawer(e, t = !1) {
    void 0 !== e &&
      (this.mainDetailsToggle.classList.remove("menu-opening"),
      this.mainDetailsToggle
        .querySelectorAll("[data-main-details-toggle]")
        .forEach((e) => {
          e.removeAttribute("open"), e.classList.remove("menu-opening");
        }),
      this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((e) => {
        e.classList.remove("submenu-open");
      }),
      document.body.classList.remove("m:overflow-hidden"),
      removeTrapFocus(t),
      this.closeAnimation(this.mainDetailsToggle),
      t.setAttribute("aria-expanded", !1),
      e instanceof KeyboardEvent && t?.setAttribute("aria-expanded", !1));
  }
  onFocusOut() {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(e) {
    const t = e.currentTarget.closest("[data-main-details-toggle]");
    this.closeSubmenu(t);
  }
  closeSubmenu(e) {
    const t = e.closest(".submenu-open"),
      i = this.querySelector("header-dropdown-menu");
    i && i.closeAll(),
      t && t.classList.remove("submenu-open"),
      e.classList.remove("menu-opening"),
      e
        .querySelector("[data-summary-button]")
        .setAttribute("aria-expanded", !1),
      removeTrapFocus(e.querySelector("[data-summary-button]")),
      this.closeAnimation(e);
  }
  closeAnimation(e) {
    let t;
    const i = (s) => {
      void 0 === t && (t = s);
      s - t < 400
        ? window.requestAnimationFrame(i)
        : (e.removeAttribute("open"),
          e.closest("[data-main-details-toggle][open]") &&
            trapFocus(
              e.closest("[data-main-details-toggle][open]"),
              e.querySelector("[data-summary-button]")
            ));
    };
    window.requestAnimationFrame(i);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super(),
      document.addEventListener("unmatchMobile", () =>
        document.body.classList.remove("m:overflow-hidden")
      );
  }
  openMenuDrawer(e) {
    (this.header_top =
      this.header_top || document.querySelector(".m-header__top-wrapper")),
      (this.header =
        this.header || document.querySelector(".m-section-header")),
      (this.mobileStickybar = document.querySelector(".m-mobile-sticky-bar")),
      (this.stickyAddTocart = document.querySelector(".m-sticky-addtocart")),
      (this.borderOffset =
        this.borderOffset ||
        this.closest(".m-header").classList.contains(
          "header-wrapper--border-bottom"
        )
          ? 1
          : 0),
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header_top.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      ),
      this.header.classList.add("menu-open"),
      setTimeout(() => {
        this.mobileStickybar &&
          (this.mobileStickybar.style.transform = "translateY(100%)"),
          this.stickyAddTocart &&
            (this.stickyAddTocart.style.transform = "translateY(100%)"),
          this.mainDetailsToggle.classList.add("menu-opening"),
          this.mainDetailsToggle.setAttribute("open", "");
      }),
      e.setAttribute("aria-expanded", !0),
      window.addEventListener("resize", this.onResize),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add("m:overflow-hidden");
  }
  closeMenuDrawer(e, t) {
    if (!t) return;
    const i = this.querySelector("header-dropdown-menu");
    i && i.closeAll(),
      super.closeMenuDrawer(e, t),
      this.header.classList.remove("menu-open"),
      this.mobileStickybar &&
        (this.mobileStickybar.style.transform = "translate(0)"),
      this.stickyAddTocart &&
        this.stickyAddTocart.style.removeProperty("transform"),
      window.removeEventListener("resize", this.onResize);
  }
  onResize = () => {
    this.header_top &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header_top.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      ),
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
  };
}
customElements.define("header-drawer", HeaderDrawer);
class HeaderDropdownMenu extends HTMLElement {
  constructor() {
    super(),
      (this.submenus = this.querySelectorAll(".m-menu-dropdown__submenu")),
      this.querySelectorAll("[data-toggle-dropdown]").forEach((e) => {
        e.addEventListener("click", this.onToggle.bind(this));
      });
  }
  onToggle(e) {
    e.preventDefault();
    const t = e.currentTarget.closest("[data-main-toggle-dropdown]"),
      i = t.querySelector(".m-menu-dropdown__submenu");
    t.hasAttribute("open")
      ? (t.removeAttribute("open"),
        t.classList.remove("menu-dropdown-open"),
        (i.style.height = i.scrollHeight + "px"),
        setTimeout(() => {
          i.style.height = "0px";
        }))
      : (t.setAttribute("open", ""),
        t.classList.add("menu-dropdown-open"),
        (i.style.height = i.scrollHeight + "px"),
        setTimeout(() => {
          i.style.height = "auto";
        }, 300));
  }
  closeAll() {
    const e = this.querySelectorAll("[data-main-toggle-dropdown]");
    e &&
      e.forEach((e) => {
        const t = e.querySelector(".m-menu-dropdown__submenu");
        e.removeAttribute("open"),
          e.classList.remove("menu-dropdown-open"),
          (t.style.height = "0px");
      });
  }
}
customElements.define("header-dropdown-menu", HeaderDropdownMenu);
class Megamenu extends HTMLElement {
  constructor() {
    super(),
      (this.template = this.dataset.template),
      (this.openDefault = "true" === this.dataset.openDefault || !1),
      (this.toggle = this.querySelector("[data-menu-toggle]")),
      (this.content = this.querySelector("[data-menu-content]")),
      (this.header = document.querySelector(".m-section-header")),
      this.init();
  }
  init() {
    (this.openDefault &&
      !this.header.classList.contains("scrolled-past-header")) ||
      (this.addEventListener("mouseenter", this.open.bind(this)),
      this.addEventListener("mouseleave", this.close.bind(this)));
  }
  close() {
    (!this.header.classList.contains("scrolled-past-header") &&
      this.openDefault) ||
      (this.classList.remove("menu-open"), this.closeAnimation(this));
  }
  open() {
    setTimeout(() => {
      this.setAttribute("open", ""), this.classList.add("menu-open");
    });
  }
  getResultsMaxHeight() {
    return (
      (this.resultsMaxHeight =
        window.innerHeight - this.toggle.getBoundingClientRect().bottom),
      this.resultsMaxHeight
    );
  }
  closeAnimation(e) {
    let t;
    const i = (s) => {
      void 0 === t && (t = s);
      s - t < 100 ? window.requestAnimationFrame(i) : e.removeAttribute("open");
    };
    window.requestAnimationFrame(i);
  }
}
customElements.define("mega-menu", Megamenu);
class DetailsModal extends HTMLElement {
  constructor() {
    super(),
      (this.detailsContainer = this.querySelector(".m-modal__container")),
      (this.mobileStickyBar = document.querySelector(".m-mobile-sticky-bar")),
      (this.headerDrawer = document.querySelector("header-drawer")),
      (this.summaryToggle = this.querySelector(".m-modal__toggle")),
      this.detailsContainer.addEventListener(
        "keyup",
        (e) => "ESCAPE" === e.code.toUpperCase() && this.close()
      ),
      this.summaryToggle.addEventListener(
        "click",
        this.onSummaryClick.bind(this)
      ),
      this.querySelectorAll('button[type="button"]').forEach((e) => {
        e.addEventListener("click", this.close.bind(this));
      }),
      this.summaryToggle.setAttribute("role", "button"),
      document.addEventListener("unmatchMobile", () =>
        document.body.classList.remove("m:overflow-hidden")
      ),
      (this.searchModal = this.querySelector(".m-search-modal")),
      this.searchModal &&
        this.style.setProperty(
          "--search-modal-height",
          `${this.searchModal.offsetHeight}px`
        );
  }
  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }
  onSummaryClick(e) {
    e.preventDefault(),
      e.target.closest(".m-modal__container").hasAttribute("open")
        ? this.close()
        : this.open(e);
  }
  onBodyClick(e) {
    (this.contains(e.target) &&
      !e.target.classList.contains("m-modal-overlay")) ||
      this.close(!1);
  }
  open(e) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    const t = e.target.closest(".m-modal__container");
    t.classList.add("m-modal-open"),
      t.setAttribute("open", !0),
      document.body.addEventListener("click", this.onBodyClickEvent),
      document.body.classList.add("m:overflow-hidden"),
      this.mobileStickyBar &&
        (this.mobileStickyBar.style.transform = "translateY(100%)"),
      setTimeout(() => {
        trapFocus(
          this.detailsContainer.querySelector('[tabindex="-1"]'),
          this.detailsContainer.querySelector('input:not([type="hidden"])')
        );
      }, 250);
  }
  close(e = !0) {
    removeTrapFocus(e ? this.summaryToggle : null),
      this.detailsContainer.classList.remove("m-modal-open"),
      setTimeout(() => {
        this.detailsContainer.removeAttribute("open");
      }, 250),
      document.body.removeEventListener("click", this.onBodyClickEvent),
      this.mobileStickyBar &&
        !this.headerDrawer.mainDetailsToggle.classList.contains(
          "menu-opening"
        ) &&
        (this.mobileStickyBar.style.transform = "translate(0)"),
      document.body.classList.remove("m:overflow-hidden");
  }
}
customElements.define("details-modal", DetailsModal);
class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    if ((super(), isStorageSupported("local"))) {
      const e = parseInt(this.dataset.productId),
        t = "minimog:recently-viewed",
        i = JSON.parse(window.localStorage.getItem(t) || "[]");
      i.includes(e) || i.unshift(e),
        window.localStorage.setItem(t, JSON.stringify(i.slice(0, 10)));
    }
  }
}
customElements.define("product-recently-viewed", ProductRecentlyViewed);
class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super(),
      (this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
      }),
      (this.productToshow = parseInt(this.dataset.productToShow)),
      (this.enableSlider = "true" === this.dataset.enableSlider),
      (this.showPagination = "true" === this.dataset.showPagination),
      (this.showNavigation = "true" === this.dataset.showNavigation),
      (this.paginationType = this.dataset.paginationType || "bullets"),
      (this.mobileLayout = this.dataset.mobileLayout),
      (this.items = this.dataset.items),
      (this.laptopItems = this.dataset.laptopItems),
      (this.tabletItems = this.dataset.tabletItems),
      (this.mobileItems = this.dataset.mobileItems || 2),
      (this.container = this.closest(".m-section")),
      MinimogTheme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600,
      });
  }
  init() {
    fetch(this.dataset.url + this.getQueryString())
      .then((e) => e.text())
      .then((e) => {
        const t = document.createElement("div");
        t.innerHTML = e;
        const i = t.querySelector("recently-viewed-products");
        (this.products = i.querySelectorAll(".m-product-card").length),
          this.products <= 0 &&
            this.container &&
            this.container.classList.add("m:hidden"),
          i &&
            i.innerHTML.trim().length &&
            ((this.innerHTML = i.innerHTML),
            this.initByScreenSize(),
            document.addEventListener("matchMobile", () => {
              this.initByScreenSize();
            }),
            document.addEventListener("unmatchMobile", () => {
              this.initByScreenSize();
            }),
            MinimogTheme.CompareProduct.setCompareButtonsState(),
            MinimogTheme.Wishlist.setWishlistButtonsState(),
            reInitTooltip(this));
      })
      .catch((e) => {});
  }
  initByScreenSize() {
    const { slideContainer: e, slideControls: t } = queryDomNodes(
      this.selectors,
      this
    );
    this.enableSlider &&
      (MinimogTheme.config.mqlMobile && "slider" !== this.mobileLayout
        ? (t && t.classList.add("m:hidden"),
          e && e.classList.remove("swiper"),
          this.swiper && this.swiper.destroy(!1, !0))
        : (t && t.classList.remove("m:hidden"), this.initSlider())),
      (!this.enableSlider || this.products <= parseInt(this.items)) &&
        t &&
        t.classList.add("m:hidden");
  }
  initSlider() {
    const { slideContainer: e, slideControls: t } = queryDomNodes(
        this.selectors,
        this
      ),
      i = t && t.querySelector(".m-slider-controls__button-prev"),
      s = t && t.querySelector(".m-slider-controls__button-next");
    e && e.classList.add("swiper");
    let o = this;
    (this.slider = new MinimogLibs.Swiper(e, {
      modules: MinimogTheme.config.swiperModules,
      slidesPerView: parseInt(this.mobileItems),
      slidesPerGroup: 1,
      threshold: 2,
      loop: !(this.products <= parseInt(this.items)),
      navigation: !!this.showNavigation && { nextEl: s, prevEl: i },
      pagination: !!this.showPagination && {
        el: this.querySelector(".swiper-pagination"),
        type: this.paginationType,
        clickable: !0,
      },
      breakpoints: {
        768: {
          slidesPerView: this.tabletItems ? parseInt(this.tabletItems) : 3,
        },
        1024: {
          slidesPerView: this.laptopItems ? parseInt(this.laptopItems) : 4,
        },
        1280: { slidesPerView: parseInt(this.items) },
      },
      threshold: 2,
      on: {
        init: function () {
          setTimeout(() => {
            const e = o.querySelector(".m-product-card");
            if (e && t) {
              const i = e.querySelector(".m-image"),
                s = t.querySelector(".m-slider-controls__button-prev"),
                o = t.querySelector(".m-slider-controls__button-next"),
                n = window.getComputedStyle(e).getPropertyValue("padding-top"),
                r = s.offsetHeight,
                a = i.clientHeight;
              t.style.setProperty("--nav-offset-top", parseInt(a) / 2 + "px"),
                t.style.setProperty(
                  "--nav-transform",
                  (-1 * parseInt(r)) / 2 + parseInt(n) + "px"
                ),
                setTimeout(() => {
                  s.classList.remove("m:opacity-0"),
                    o.classList.remove("m:opacity-0");
                }, 150);
            }
          }, 100);
        },
      },
    })),
      (this.swiper = e && e.swiper);
  }
  getQueryString() {
    const e = JSON.parse(
      window.localStorage.getItem("minimog:recently-viewed") || "[]"
    );
    return (
      this.dataset.productId &&
        e.includes(parseInt(this.dataset.productId)) &&
        e.splice(e.indexOf(parseInt(this.dataset.productId)), 1),
      e
        .map((e) => "id:" + e)
        .slice(0, this.productToshow)
        .join(" OR ")
    );
  }
}
if (
  (customElements.define("recently-viewed-products", RecentlyViewedProducts),
  !customElements.get("product-tabs"))
) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.buttonWrapper = this.querySelector(".m-product-tabs__buttons")),
        (this.buttons = this.querySelectorAll(".m-product-tabs__button")),
        (this.buttons_more = this.querySelectorAll(
          ".m-product-tabs__button-more"
        )),
        (this.contentWrapper = this.querySelector(".m-product-tabs__contents")),
        (this.templates = this.querySelector("template").content.cloneNode(!0)),
        (this.productToshow = parseInt(this.dataset.productToShow)),
        (this.showPagination = "true" === this.dataset.showPagination),
        (this.showNavigation = "true" === this.dataset.showNavigation),
        (this.paginationType = this.dataset.paginationType || "bullets"),
        (this.mobileLayout = this.dataset.mobileLayout),
        (this.items = this.dataset.items),
        (this.laptopItems = this.dataset.laptopItems),
        (this.tabletItems = this.dataset.tabletItems),
        (this.mobileItems = this.dataset.mobileItems || 2),
        (this.currentActiveIndex = -1),
        (this.currentTab = null),
        (this.sectionId = this.dataset.sectionId),
        this.buttons.forEach((e) => {
          e.addEventListener("click", this.onButtonClick.bind(this));
        }),
        this.setActiveTab(0),
        Shopify.designMode &&
          document.addEventListener("shopify:block:select", (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            const t = e && e.target,
              i = t && Number(t.dataset.tabIndex);
            this.setActiveTab(i);
          });
    }
    onButtonClick(e) {
      const t = e.currentTarget,
        i = t.dataset.tabIndex;
      t.hasAttribute("data-active") || this.setActiveTab(i);
    }
    setActiveTab(e) {
      let t, i, s, m, n;
      (this.contents = this.querySelectorAll(".m-product-tabs__content")),
        (t = this.buttons && this.buttons[this.currentActiveIndex]),
        (i = this.buttons && this.buttons[e]),
        (m = this.buttons_more && this.buttons_more[this.currentActiveIndex]),
        (n = this.buttons_more && this.buttons_more[e]),
        (this.tabContentActive = this.templates.querySelector(
          `[data-tab-index="${e}"]`
        )),
        (this.tabButtonActive = this.buttonWrapper.querySelector(
          `[data-tab-index="${e}"]`
        )),
        this.tabContentActive &&
          this.contentWrapper.appendChild(this.tabContentActive),
        (this.tabContentActive = this.tabContentActive
          ? this.tabContentActive
          : this.contentWrapper.querySelector(`[data-tab-index="${e}"]`)),
        (s = this.tabContentActive),
        t && t.classList.remove("m-tab-active"),
        m && m.classList.remove("m-tab-active"),
        this.currentTab && this.currentTab.classList.remove("m-tab-active"),
        t && t.removeAttribute("data-active"),
        m && m.removeAttribute("data-active"),
        i && i.classList.add("m-tab-active"),
        i && i.setAttribute("data-active", !0),
        n && n.classList.add("m-tab-active"),
        n && n.setAttribute("data-active", !0),
        s && s.classList.add("m-tab-active"),
        (this.enableSlider =
          this.tabContentActive &&
          "true" === this.tabContentActive.dataset.enableSlider),
        (this.slideControls =
          this.tabContentActive &&
          this.tabContentActive.querySelector(".m-slider-controls")),
        (this.slideContainer =
          this.tabContentActive &&
          this.tabContentActive.querySelector(".m-mixed-layout__wrapper")),
        MinimogTheme.Wishlist &&
          MinimogTheme.Wishlist.setWishlistButtonsState(),
        MinimogTheme.CompareProduct &&
          MinimogTheme.CompareProduct.setCompareButtonsState(),
        this.initByScreenSize(
          this.enableSlider,
          this.slideContainer,
          this.slideControls
        ),
        document.addEventListener("matchMobile", () => {
          this.initByScreenSize(
            this.enableSlider,
            this.slideContainer,
            this.slideControls
          );
        }),
        document.addEventListener("unmatchMobile", () => {
          this.initByScreenSize(
            this.enableSlider,
            this.slideContainer,
            this.slideControls
          );
        }),
        reInitTooltip(s),
        (this.currentActiveIndex = e),
        (this.currentTab = s);
    }
    initByScreenSize(e, t, i) {
      e &&
        (MinimogTheme.config.mqlMobile && "slider" !== this.mobileLayout
          ? (i && i.classList.add("m:hidden"),
            t && t.classList.remove("swiper"),
            this.swiper && this.swiper.destroy(!1, !0))
          : (i && i.classList.remove("m:hidden"), this.initSlider(t, i)));
    }
    initSlider(e, t) {
      const i = t && t.querySelector(".m-slider-controls__button-prev"),
        s = t && t.querySelector(".m-slider-controls__button-next"),
        o = t && t.querySelector(".swiper-pagination");
      e && e.classList.add("swiper"),
        (this.slider = new MinimogLibs.Swiper(e, {
          modules: MinimogTheme.config.swiperModules,
          slidesPerView: parseInt(this.mobileItems),
          slidesPerGroup: 1,
          threshold: 2,
          loop: !0,
          navigation: !!this.showNavigation && { nextEl: s, prevEl: i },
          pagination: !!this.showPagination && {
            el: o,
            type: this.paginationType,
            clickable: !0,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems ? parseInt(this.tabletItems) : 3,
            },
            1024: {
              slidesPerView: this.laptopItems ? parseInt(this.laptopItems) : 4,
            },
            1280: { slidesPerView: parseInt(this.items) },
          },
          threshold: 2,
          on: {
            init() {
              setTimeout(() => {
                window.dispatchEvent(new Event("resize"));
                const i = e.querySelector(".m-product-card");
                const content = e.querySelector(".m-mixed-layout__inner");
                if (i && t) {
                  const e =
                      i.querySelector(".m-image") ||
                      i.querySelector(".m-placeholder-svg"),
                    s = t.querySelector(".m-slider-controls__button-prev"),
                    o = t.querySelector(".m-slider-controls__button-next"),
                    n = window
                      .getComputedStyle(i)
                      .getPropertyValue("padding-top"),
                    r = s.offsetHeight,
                    a = e.clientHeight;
                    const contentHeight = content.clientHeight;
                  t.style.setProperty(
                    "--nav-offset-top",
                    parseInt(parseInt(contentHeight) / 7) * 3 + "px"
                  ),
                    t.style.setProperty(
                      "--nav-transform",
                      (-1 * parseInt(r)) / 2 + parseInt(n) + "px"
                    ),
                    setTimeout(() => {
                      s.classList.remove("m:opacity-0"),
                        o.classList.remove("m:opacity-0");
                    }, 150);
                }
              }, 150);
            },
          },
        })),
        (this.swiper = e && e.swiper);
    }
  }
  customElements.define("product-tabs", e);
}
if (!customElements.get("m-collection-spotlight")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.selectors = {
          products: [".m-product-card"],
          featuredProductMediaMain: ".m-product-featured__media-main",
          featuredProductMediaMainWrapper:
            ".m-product-featured__media-main-wrapper",
          featuredProductMediaThumb: ".m-product-featured__media-thumb",
          featuredProductMediaThumbWrapper:
            ".m-product-featured__media-thumb-wrapper",
          slideContainer: ".m-mixed-layout__wrapper",
          slideContainerWrapper: ".m-collection-spotlight__product-list",
          slideControls:
            ".m-collection-spotlight__product-list .m-slider-controls",
        }),
        (this.domNodes = queryDomNodes(this.selectors, this)),
        (this.enableSlider = "true" === this.dataset.enableSlider),
        (this.paginationType = this.dataset.paginationType || "bullets"),
        (this.mobileLayout = this.dataset.mobileLayout),
        (this.items = this.dataset.items),
        (this.mobileItems = this.dataset.mobileItems || 2),
        this.initFeaturedProduct(),
        this.initByScreenSize(),
        document.addEventListener("matchMobile", () => {
          this.initByScreenSize();
        }),
        document.addEventListener("unmatchMobile", () => {
          this.initByScreenSize();
        });
    }
    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer: e, slideControls: t } = queryDomNodes(
        this.selectors,
        this
      );
      MinimogTheme.config.mqlMobile && "slider" !== this.mobileLayout
        ? (t && t.classList.add("m:hidden"),
          e && e.classList.remove("swiper"),
          this.swiper && this.swiper.destroy(!1, !0))
        : (t && t.classList.remove("m:hidden"), this.initSlider());
    }
    initSlider() {
      const { slideContainer: e, slideContainerWrapper: t } = queryDomNodes(
          this.selectors,
          this
        ),
        i = t && t.querySelector(".m-slider-controls__button-prev"),
        s = t && t.querySelector(".m-slider-controls__button-next");
      e && e.classList.add("swiper"),
        (this.slider = new MinimogLibs.Swiper(e, {
          modules: [
            MinimogLibs.Swiper.Navigation,
            MinimogLibs.Swiper.Pagination,
            MinimogLibs.Swiper.Grid,
          ],
          slidesPerView: parseInt(this.mobileItems),
          slidesPerGroup: 1,
          threshold: 2,
          grid: { rows: 1, fill: "column" },
          navigation: { nextEl: s, prevEl: i },
          pagination: {
            el: t.querySelector(".swiper-pagination"),
            type: "fraction",
            clickable: !0,
          },
          breakpoints: {
            1280: {
              slidesPerView: 1,
              pagination: { type: "bullets" },
              grid: { rows: 2, fill: "row" },
            },
          },
        })),
        (this.swiper = e && e.swiper);
    }
    initFeaturedProduct() {
      const e = [
          ...MinimogTheme.config.swiperModules,
          MinimogLibs.Swiper.Thumbs,
        ],
        {
          featuredProductMediaMain: t,
          featuredProductMediaThumb: i,
          featuredProductMediaMainWrapper: s,
          featuredProductMediaThumbWrapper: o,
        } = queryDomNodes(this.selectors, this),
        n = s && s.querySelector(".m-slider-controls__button-prev"),
        r = s && s.querySelector(".m-slider-controls__button-next"),
        a = o && o.querySelector(".m-slider-controls__button-prev"),
        l = o && o.querySelector(".m-slider-controls__button-next");
      t && t.classList.add("swiper");
      const d = new MinimogLibs.Swiper(i, {
          modules: e,
          direction: "vertical",
          spaceBetween: 10,
          slidesPerView: 5,
          watchOverflow: !0,
          navigation: { nextEl: l, prevEl: a },
          breakpoints: {
            1024: { slidesPerView: 7 },
            1280: { slidesPerView: 5 },
          },
        }),
        c = new MinimogLibs.Swiper(t, {
          modules: e,
          thumbs: { swiper: d },
          navigation: { nextEl: r, prevEl: n },
          pagination: {
            el: s.querySelector(".swiper-pagination"),
            type: "fraction",
            clickable: !0,
          },
        });
      let h = !0,
        m = "",
        u = [];
      c.on("slideChange", (e) => {
        window.pauseAllMedia(this);
        try {
          const { slides: t, activeIndex: i } = e;
          u = [i];
          for (let e of u) {
            const i = t[e];
            if ((i && (m = i.dataset.mediaType), "model" === m)) break;
          }
          "model" === m
            ? ((c.allowTouchMove = !1), (h = !1))
            : (h || (c.allowTouchMove = !0), (h = !0));
        } catch (e) {}
      });
    }
  }
  customElements.define("m-collection-spotlight", e);
}
if (!customElements.get("m-form-subscribe")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.form = this.querySelector("form")),
        (this.agreeTerms = this.querySelector("[name='agree_terms']")),
        (this.errorWrapper = this.querySelector(".m-product-form-message")),
        (this.buttonSubmit = this.querySelector(".m-newsletter-form__button")),
        (this.input = this.querySelector(".m-newsletter-form__input")),
        this.buttonSubmit.addEventListener(
          "click",
          this.hanldeSubmit.bind(this)
        );
    }
    hanldeSubmit(e) {
      e.preventDefault();
      let t = !0;
      return "" == this.input.value
        ? ((t = !1),
          window.MinimogTheme.Notification.show({
            target: this.errorWrapper,
            method: "appendChild",
            type: "warning",
            message: "Email cannot be blank",
          }))
        : this.validateEmail(this.input.value)
        ? !this.agreeTerms || this.agreeTerms.checked
          ? void (t && this.form.submit())
          : ((t = !1),
            window.MinimogTheme.Notification.show({
              target: this.errorWrapper,
              method: "appendChild",
              type: "warning",
              message: "Please agree to the Terms and Conditions",
            }))
        : ((t = !1),
          window.MinimogTheme.Notification.show({
            target: this.errorWrapper,
            method: "appendChild",
            type: "warning",
            message: "Please enter the correct email syntax",
          }));
    }
    validateEmail(e) {
      return String(e)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    }
  }
  customElements.define("m-form-subscribe", e);
}
